/* WL Studio bar v5 — Summer's round 2026-07-10 (R1–R8 spec):
   · the bar stops being a tab launcher: the 7-tab row is GONE (R5). Functions live
     where the customer is — customise/sets/wall on the PDP, Papers & Murals in a
     temporary quiet menu (R3), Help Me Choose beside the search (R2).
   · Saved strip lives in the PAGE BODY only (R1): catalogue toolbar next to the
     product count (body-row fallback above the grid, never in the bar), and on the
     PDP inside the share section with "← Back to your search" (state restored from
     localStorage wl_last_search).
   · product pages show NO search bar (Summer + agent agree) — the bar hides itself
     on /products/ and only the PDP modules + cart chip remain.
   · z-index dropped so the theme's header dropdowns are never covered.
   · front-page search (R6) posts here via /collections/all?wlq=…&wlhelp=1&wlcam=1.
   Served from R2 app/bar.js. */
(function () {
  try {
  const API = "https://wl-studio.wallliberation.workers.dev";
  // Footprint beacons (Summer 2026-08-13, /report build): card clicks + saves,
  // the two moves GA4 can't attribute to an artwork. Fire-and-forget into the
  // worker's clog feed (7-day KV, archived nightly to R2, mirrored to report.db).
  // Anonymous session id since 2026-08-28 (Summer's yes, attribution build):
  // a random code only — no name, no email, no cookies. Hard cap per page view.
  let SRC = null;
  let wlPingN = 0;
  const wlPing = function (step, extra) { try {
    if (++wlPingN > 30) return;
    const body = JSON.stringify(Object.assign(
      { step: step, pg: (location.pathname + location.search).slice(0, 160),
        sid: (SRC && SRC.sid) || undefined }, extra || {}));
    // NOT sendBeacon: it forces credentials-include, which the worker's
    // wildcard CORS rejects on preflight (live-tested 2026-08-13). keepalive
    // fetch survives navigation the same way without the credential clash.
    fetch(API + "/api/clog", { method: "POST", keepalive: true,
      headers: { "content-type": "application/json" }, body: body }).catch(function () {});
  } catch (e) {} };
  // Attribution build 2026-08-28: the first-visit capture lives in
  // wl_search.js (the one module EVERY page loads). Here we only read the
  // stored source so each ping carries the anonymous session id.
  try { SRC = JSON.parse(localStorage.wl_src || "null"); } catch (e) {}
  // every artwork link on any page (theme grids, collections, related, search):
  // which artwork was opened, from where. Capture phase so it fires before nav.
  document.addEventListener("click", function (e) { try {
    const a = e.target && e.target.closest && e.target.closest('a[href*="/products/"]');
    if (!a) return;
    const h = (a.getAttribute("href").match(/\/products\/([a-z0-9-]+)/) || [])[1];
    if (h) wlPing("card-click", { h: h.slice(0, 80) });
  } catch (err) {} }, true);
  // The print-page skeleton that used to live here (2026-07-24) is gone. It hid
  // the product columns from JS and revealed them again on a 3s setTimeout. That
  // failsafe was not a safety net, it was the bug: on a slow phone the timer won
  // the race and showed the visitor the raw theme layout — width grid, height
  // grid, framing list — which is exactly what Summer photographed on 4G.
  // The cover is now pure CSS in wl-overrides.css, armed by an inline script in
  // sections/wl-studio-bar.liquid, and it reveals on a REAL end-of-build signal
  // (body.wl-c-ready) or on a REAL script error, never on a clock. (2026-08-24)
  const root = document.getElementById("wl-studio-root");
  if (!root || root.dataset.wlDone) return;
  root.dataset.wlDone = "1";
  const IS_PDP = location.pathname.includes("/products/");
  const IS_OWN = location.pathname.indexOf("print-stretch-and-frame-your-own-art") !== -1;
  // WL 2026-07-29 (Summer): the murals collection needs no art-search hero and no
  // saved-artworks strip — murals are composed in their own designer, not saved.
  const IS_MURALS = /\/collections\/pre-designed-wall-murals/.test(location.pathname);
  if (IS_MURALS) root.style.display = "none";
  const IS_HOME = location.pathname === "/" || /^\/index\.html?$/.test(location.pathname);
  const S = { cards: [], shown: [], sel: JSON.parse(localStorage.wl_selected || "[]"),
              pending: JSON.parse(localStorage.wl_pending || "[]"),
              studioCount: +(localStorage.wl_studio_count || 0),
              email: localStorage.wl_email || "", active: null, lastResults: null,
              help: {} };
  // ONE colour function (wl_colour.js, 2026-07-30 · flipped 2026-08-20): the
  // colour dots FILTER through Summer's curated tags first (measured palette
  // only for untagged cards); measured palettes still soft-RANK within the set
  // 2026-07-31: colour/customiser load from the theme CDN when the liquid
  // exposes the asset URLs (window.__wlAssets, sections/wl-studio-bar.liquid) —
  // workers.dev cost an extra origin handshake + 60 s cache on mobile first
  // loads. The API fallback keeps old cached HTML working.
  const ASSET = window.__wlAssets || {};
  if (!window.WLColour) {
    const cjs = document.createElement("script");
    cjs.src = ASSET.colour || (API + "/app/colour.js");
    cjs.onload = () => { try { if (CHIP.colours.length) applyChips(); } catch (e) {} };
    document.head.appendChild(cjs);
  }
  const money = v => "A$" + Number(v).toLocaleString("en-AU");
  const track = (ev, p) => { try {
    if (typeof window.gtag === "function") window.gtag("event", ev, p || {});
    (window.dataLayer = window.dataLayer || []).push({ event: ev, ...(p || {}) });
  } catch (e) {} };
  // titles are "Descriptor | Name", "Name | LE descriptor" or "Artist | Descriptor | Name"
  // — always show the artwork NAME segment (the old slice(0,2) showed the SEO
  // descriptor on artist-prefixed titles, which read as a wrong/stale title)
  const DESCRE = /canvas|wall art|print|limited edition|open edition/i;
  const dispTitle = (t, artist) => {
    let ps = String(t || "").split("|").map(s => s.trim()).filter(Boolean);
    if (ps.length > 1 && artist && ps[0].toLowerCase() === String(artist).trim().toLowerCase()) ps = ps.slice(1);
    const names = ps.filter(p => !DESCRE.test(p));
    return names.length ? names[names.length - 1] : (ps[ps.length - 1] || "");
  };
  // "Various Artists" is a placeholder, not a person — treat it as no artist
  // rather than printing it on a card (Summer: never show an invented value)
  const artistOf = c => { const a = String((c && c.artist) || "").trim();
    return (!a || /^various artists$/i.test(a)) ? "" : a; };
  // one label rule for every card, everywhere: "Artist · Name", or just the
  // Name when the artist field is genuinely empty (82 Open Editions, 2026-07-15)
  const cardLabel = c => { if (!c) return "";
    const a = artistOf(c), n = dispTitle(c.title, c.artist);
    return a && n && a.toLowerCase() !== n.toLowerCase() ? a + " · " + n : (n || a); };
  // Summer 2026-09-07: the artwork NAME leads in the theme's own title style and the
  // ARTIST follows on the SAME line, its own colour and a smaller size. Used by BOTH
  // the default grid and the search grid, so a card never changes shape when results
  // come back. That split is also why the 49 limited editions read as nameless.
  const esc = t => String(t).replace(/[&<>"]/g, m => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[m]));
  const cardLabelHTML = c => { if (!c) return "";
    const a = artistOf(c), n = dispTitle(c.title, c.artist);
    if (!n) return esc(a);
    return '<span class="wl-card-name">' + esc(n) + '</span>' +
      (a && a.toLowerCase() !== n.toLowerCase()
        ? '<span class="wl-card-artist">' + esc(a) + '</span>' : ""); };
  const byI = i => S.cards.find(c => c.index === i);
  // image version-buster: Shopify bumps ?v= on every photo swap; carrying it onto
  // our /thumbs//main URLs makes a changed photo a NEW url, so no browser or CDN
  // can show yesterday's image for 24h (the R2 bytes refresh, the URL didn't)
  const iv = c => { const m = /[?&]v=(\d+)/.exec((c && c.image) || ""); return m ? "?v=" + m[1] : ""; };
  // 8s cap, one retry, real status check (Summer 2026-08-24). This had none of
  // the three: a stalled /api/library hung the boot for as long as the phone
  // held the socket open, and a 500 threw inside r.json() — either way every-
  // thing downstream of the .then() was skipped, silently.
  const api = (p, b, tries) => {
    const ctl = typeof AbortController === "function" ? new AbortController() : null;
    const opt = b ? { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(b) } : {};
    if (ctl) opt.signal = ctl.signal;
    const t = setTimeout(() => { try { if (ctl) ctl.abort(); } catch (e) {} }, 8000);
    return fetch(API + p, opt).then(r => {
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json();
    }).then(j => { clearTimeout(t); return j; },
            e => { clearTimeout(t);
                   // GETs ONLY. A POST may have already reached the server and done
                   // its work before the 8s abort: /api/enquiry mails Summer AND the
                   // customer before it answers, and the Turnstile token is single
                   // use — so a retry sent the emails twice and THEN failed the
                   // customer with a spent token. Found by audit, 2026-08-24.
                   if (b || (tries || 0) >= 1) throw e;
                   return api(p, b, (tries || 0) + 1); });
  };
  const TSK = "0x4AAAAAAD0-wshBVMBagcB3";      // Turnstile sitekey — enquiry endpoints want a token
  const tsGet = () => new Promise(res => { try {
    const run = () => {
      const host = document.createElement("div");
      host.style.cssText = "position:fixed;bottom:14px;right:14px;z-index:2147483000";
      document.body.appendChild(host);
      let done = false; const fin = t => { if (done) return; done = true;
        setTimeout(() => { try { host.remove(); } catch (e) {} }, 600); res(t || null); };
      try { window.turnstile.render(host, { sitekey: TSK, appearance: "interaction-only",
        callback: fin, "error-callback": () => fin(null), "expired-callback": () => fin(null) });
      } catch (e) { fin(null); }
      setTimeout(() => fin(null), 30000);
    };
    if (window.turnstile) run();
    else { const s = document.createElement("script");
      s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      s.onload = run; s.onerror = () => res(null); document.head.appendChild(s); }
  } catch (e) { res(null); } });
  const savePending = () => { try { localStorage.wl_pending = JSON.stringify(S.pending); } catch (e) {} };

  root.innerHTML = `
  <style>
   #wlb{font-family:'Fraunces',Georgia,serif;border:none;background:#fff;position:sticky;top:0;z-index:1}
   #wlb .row{display:flex;justify-content:center;align-items:center;gap:12px;padding:12px 14px 4px;flex-wrap:wrap}
   #wlb .alla{font:9.5px Helvetica;letter-spacing:.08em;text-transform:uppercase;color:#1b1b1b;
     text-decoration:none;white-space:nowrap;border:1px solid #1b1b1b;padding:5px 10px;background:#fff;
     cursor:pointer;margin-left:6px;border-radius:0;line-height:1.3;display:inline-block}
   #wlb .alla:hover{background:#1b1b1b;color:#fff}
   #wlb .srch{display:flex;border:1px solid #1b1b1b;width:min(680px,100%);position:relative}
   #wlprog{position:absolute;left:0;right:0;bottom:0;height:3px;overflow:hidden;display:none}
   #wlprog.on{display:block}
   #wlprog i{position:absolute;top:0;left:0;height:100%;width:40%;background:var(--wlbtn,#425934);animation:wlslide 1.05s ease-in-out infinite}
   @keyframes wlslide{0%{left:-40%}100%{left:100%}}
   #wlb input{flex:1;border:none;padding:11px 13px;font-size:.95rem;font-family:inherit;outline:none;min-width:0}
   #wlb .go{border:none;background:var(--wlbtn,#425934);color:var(--wlbtnfg,#fff);padding:0 20px;cursor:pointer;
     font-size:13px;font-weight:700;letter-spacing:.08em;text-transform:uppercase}
   /* Source stands apart from the search bar (Summer 2026-09-02) — same look
      as Search, stretched to the bar's height, separated by the row gap */
   #wlb #wlsrcbtn{align-self:stretch}
   #wlb .cam{border:none;background:#fff;padding:0 12px;cursor:pointer;font-size:15px}
   #wlb .hmc{border:none;border-left:1px solid #e6e2dc;background:#fff;padding:0 14px;cursor:pointer;font:10px Helvetica;letter-spacing:.1em;text-transform:uppercase;color:#555;white-space:nowrap}
   #wlb .hmc:hover{color:#1b1b1b}
   #wlb .echo{text-align:center;font:12.5px Helvetica;color:#6b6b6b;min-height:15px;padding:2px 10px}
   #wlb .tmenu{text-align:center;font:10px Helvetica;letter-spacing:.12em;text-transform:uppercase;padding:0 12px 10px}
   #wlb .tmenu a{color:#425934;text-decoration:none;border-bottom:1px solid #c3ccb8;padding-bottom:1px;margin:0 8px}
   #wlb .tmenu a:hover{color:#1b1b1b;border-color:#1b1b1b}
   #wlb .panel{padding:8px 16px 12px;text-align:center;font:12px Helvetica;color:#444}
   #wlb select,#wlb .qin{font:12px Helvetica;padding:6px;border:1px solid #e6e2dc}
   #wlb .qin{width:56px}
   #wlb .btn{background:var(--wlbtn,#425934);color:var(--wlbtnfg,#fff);border:none;padding:9px 18px;font:10px Helvetica;letter-spacing:.14em;text-transform:uppercase;cursor:pointer}
   #wlb .lnk{background:none;border:none;color:#425934;text-decoration:underline;cursor:pointer;font:11px Helvetica}
   #wlb .chips{padding:4px 12px 8px}
   #wlb .wlchips-dd{display:flex;flex-wrap:wrap;gap:7px;justify-content:center;align-items:center}
   #wlb .wlchips-co{display:flex;flex-wrap:wrap;gap:7px;justify-content:center;align-items:center;margin-top:9px}
   #wlb .wldots{display:flex;flex-wrap:wrap;gap:7px;align-items:center;justify-content:center}
   #wlb .chip{border:1px solid #e6e2dc;background:#fff;border-radius:999px;padding:5px 13px;font:11px Helvetica;color:#555;cursor:pointer}
   #wlb .chip.on{border-color:#1b1b1b;background:#1b1b1b;color:#fff}
   #wlb .dot{width:18px;height:18px;border-radius:50%;border:2px solid #fff;outline:1px solid #ddd;cursor:pointer;padding:0}
   #wlb .dot.on{outline:2px solid #1b1b1b}
   #wlhead{text-align:center;padding:22px 16px 2px}
   #wlhead h2{font-weight:normal;font-size:1.45rem;margin:6px 0 4px;letter-spacing:.01em}
   #wlhead .sub{display:none}          /* sub-line removed everywhere, Summer 2026-09-07 */
  /* the theme rounds every select on a phone; these are square like the desktop ones */
  #wlb .wlchips-dd select{border-radius:0}
   #wlchip-lab{font:9.5px Helvetica;letter-spacing:.14em;color:#888;text-transform:uppercase;margin-left:10px}
   #wlcartchip{position:fixed;left:18px;bottom:64px;z-index:80;display:none;background:var(--wlbtn,#425934);color:var(--wlbtnfg,#fff);border:none;padding:11px 18px;font:10px Helvetica;letter-spacing:.14em;text-transform:uppercase;cursor:pointer;box-shadow:0 4px 18px rgba(0,0,0,.22)}
   /* own stacking context: the ✕ (z65) and hover-zoom (z60) compete only inside
      the strip — without it they painted THROUGH the header menu (header z4) */
   .wltbstrip{display:inline-flex;align-items:center;gap:5px;margin-left:0;vertical-align:middle;flex-wrap:nowrap;white-space:nowrap;position:relative;z-index:1}
   /* Summer 2026-07-13: no hover-zoom (popped over neighbours + carried the ✕
      with it); hover = border highlight only, ✕ sits INSIDE the thumb and only
      shows while hovering that thumb */
   .wltbstrip img{width:50px;height:50px;object-fit:cover;border:2px solid #e6e2dc;cursor:pointer;display:block;transition:border-color .15s ease}
   .wltbstrip [data-i]:hover img{border-color:var(--wlbtn,#425934)}
   .wltbstrip .on img{border-color:var(--wlbtn,#425934)}
   .wltbstrip .lbl{font:10px Helvetica;letter-spacing:.1em;color:#666;text-transform:uppercase;white-space:nowrap}
   .wltbstrip [data-x]{position:absolute;top:2px;right:2px;width:16px;height:16px;border:none;border-radius:50%;background:rgba(20,20,20,.7);color:#fff;font-size:9px;line-height:1;cursor:pointer;z-index:2;display:none}
   .wltbstrip [data-i]:hover [data-x]{display:block}
   #wlcount{white-space:normal;line-height:1.6;text-align:left}
   /* the theme owns these two classes (wl-overrides.css) — the search grid writes
      the SAME ones so a card looks identical before and after a search */
   .wl-card-name{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-width:0;flex:0 1 auto}
   .wl-card-artist{color:#8a6d3b;font-size:.82em;letter-spacing:.03em;white-space:nowrap;flex:none}
   .collection-toolbar{flex-wrap:wrap}
   /* two 50/50 zones, each centered: left = breadcrumb OR match text, right = saved */
   #wlstriprow{display:grid;grid-template-columns:1fr 1fr;align-items:center;column-gap:16px;min-width:0;box-sizing:border-box}
   /* the count/match line reads from the LEFT edge of its zone (Summer 2026-09-07)
      — centred inside a half-width zone looked like a stray, badly placed number */
   #wlzl{display:flex;align-items:center;justify-content:flex-start;gap:10px;min-width:0;text-align:left}
   #wlzr{display:flex;align-items:center;justify-content:center;gap:10px;min-width:0;text-align:center}
   #wlzl nav,#wlzl .breadcrumb{margin:0}
   #wlstriprow .wltbstrip{flex-wrap:wrap;white-space:normal;row-gap:10px;justify-content:center}
   @media (max-width:700px){#wlstriprow{grid-template-columns:1fr;row-gap:8px;margin-top:-12px !important;padding-top:2px !important;padding-bottom:2px !important}}
   /* one line on a phone: Saved (n) + six thumbs + arrows + View all + mail.
      Sized to fit 375px — wrapping is what put it on two lines. (2026-07-15) */
   @media (max-width:700px){
     .wltbstrip{flex-wrap:nowrap !important;white-space:nowrap;gap:3px !important;justify-content:center}
     /* 34px is the ceiling with Saved(n) + arrows + View all + mail on the same
        line at 375px (chrome eats ~129px of 355). Bigger means dropping one. */
     .wltbstrip img{width:34px !important;height:34px !important}
     .wltbstrip .lbl{font-size:9.5px !important;letter-spacing:0 !important}
     .wltbstrip .lnk{font-size:9.5px !important}
     .wltbstrip [data-pg]{padding:1px 4px !important;font-size:10px}
     .wltbstrip [data-mail] svg{width:16px !important;height:16px !important}
     .wltbstrip [data-x]{transform:scale(.8)}
   }
   /* Summer 2026-07-31 pass 3: the strip's height IS the buttons — no grey band above
      or below them. Share carried only its inline skin (7px/14px, inherited 19.8px
      line-height) so it stood ~7px taller than Back/Save and set the row height,
      leaving a 3.5px gap over and under the other two. One rule covers all three;
      the ≤700px block below re-tightens the same selector for phones.
      Two IDs deep on purpose: wl-overrides.css ships an !important rule on
      "#wlacts #wlback, #wlacts #wlsavepdp" — a lighter selector here loses to it. */
   #wlacts{margin:0 !important}
   #wlacts #wlback,#wlacts #wlsavepdp,#wlacts #wlsharebtn{
     padding:5px 12px !important;font-size:12px !important;
     line-height:1.4 !important;min-height:0 !important;box-sizing:border-box}
   /* Summer 2026-07-31 pass 4 — the REAL band. The grey is body bg showing between the
      white header and the white product card; the strip's own box was already flush,
      which is why pass 3 measured 0 and still looked padded. Two outside boxes made it:
      (a) #wlgrid — the saved-drawer grid, empty and zero-height but the FIRST thing in
          <main> — carries margin-top:20px, which collapses out through its zero-height
          parents and pushes all of <main> down 20px = the gap ABOVE the buttons;
      (b) the theme's own 10px padding-block-start on the main-product section = BELOW.
      :empty keeps the 20px for the real grid once cards are rendered into it. */
   #wlgrid:empty{display:none !important}
   .shopify-section--wl-breadcrumb+.shopify-section--main-product{padding-block-start:0 !important}
   /* PDP saved strip: its own tidy full-width centred row (was crooked in the breadcrumb) */
   @media (max-width:700px){#wlpdpstrip{width:100% !important;max-width:100% !important;margin:8px 0 4px !important}.wlpdp-shost{flex:1 1 100% !important;width:100% !important}#wlpdpstrip .wltbstrip{flex-wrap:wrap !important;justify-content:center !important;align-items:center !important;row-gap:8px !important;width:100% !important}
   /* Back + Save + Share share one centred row (was: #wlback forced to its own full-width line).
      Trimmed 2026-07-15: adding Save pushed the share icons onto a second line —
      drop the "Share" word (the icons say it) and tighten the buttons. */
   /* Summer 2026-07-31: strip hugs the header — no extra top margin */
   #wlacts{flex:1 1 100% !important;justify-content:center !important;margin:0 !important;gap:8px !important;
     padding:0 10px;box-sizing:border-box;flex-wrap:nowrap}
   #wlacts #wlback,#wlacts #wlsavepdp,#wlacts #wlsharebtn{
     font-size:11px !important;padding:5px 10px !important;white-space:nowrap}
   #wlacts #wlsharetop .smallcaps{display:none !important}}
   #wlacts #wlsharetop{margin:0 !important;padding:0 !important}
   #wlacts #wlsharetop .h-stack,#wlacts #wlsharetop share-button{margin:0 !important}
   .wlsel{display:inline-flex;align-items:center;gap:5px;margin-top:2px;border:1px solid #d8d3cb;background:#fff;border-radius:999px;padding:3px 9px;font:10.5px Helvetica;letter-spacing:.06em;color:#666;cursor:pointer;flex:0 0 auto}
   .wlsel.on{background:var(--wlbtn,#425934);border-color:var(--wlbtn,#425934);color:var(--wlbtnfg,#fff)}
   /* Save sitting on the artwork image — works in every grid layout */
   .wlsel--img{position:absolute;right:8px;bottom:8px;z-index:3;margin-top:0 !important;
     background:rgba(255,255,255,.93);box-shadow:0 1px 6px rgba(0,0,0,.16)}
   .wlsel--img.on{background:var(--wlbtn,#425934)}
   #wlqv{position:fixed;right:0;top:0;bottom:0;width:min(440px,100%);background:#fff;border-left:1px solid #1b1b1b;box-shadow:-8px 0 30px rgba(0,0,0,.12);z-index:70;display:none;overflow:auto;padding:20px;font:13px Georgia}
   #wlgrid{display:grid;grid-template-columns:repeat(auto-fill,minmax(210px,1fr));gap:22px;margin-top:20px;font-family:Georgia,serif}
   #wlgrid .c{position:relative;cursor:pointer}
   #wlgrid img{width:100%;aspect-ratio:1/1.1;object-fit:cover;background:#eee}
   #wlgrid .chk{position:absolute;top:8px;right:8px;width:25px;height:25px;border:2px solid #fff;background:rgba(0,0,0,.18);color:#fff;border-radius:3px;cursor:pointer}
   #wlgrid .chk.on{background:#425934;border-color:#425934}
   #wlgrid .t{font-size:.8rem;text-align:center;margin-top:4px;line-height:1.2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0 4px}
   #wlgrid .p{font:11px/1.2 Helvetica;color:#6b6b6b;text-align:center;margin-top:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
   #wlov{position:fixed;inset:0;z-index:2147483000;background:#fff;display:none;flex-direction:column}
   #wlov .hd{display:flex;align-items:center;justify-content:space-between;padding:10px 16px;border-bottom:1px solid #1b1b1b;font-family:Georgia,serif}
   #wlov .hd b{font-weight:normal;letter-spacing:.12em;font-size:.85rem}
   #wlov .hd button{border:1px solid #1b1b1b;background:#fff;padding:6px 14px;cursor:pointer;font-family:inherit;font-size:.8rem}
   #wlov iframe{flex:1;border:none;width:100%}
   #wlhelpov{position:fixed;inset:0;z-index:2147482800;background:rgba(20,20,20,.55);display:none;align-items:flex-end;justify-content:center}
   @media(min-width:700px){#wlhelpov{align-items:center}}
   #wlhelp{background:#fff;width:min(620px,100%);max-height:92vh;overflow:auto;padding:22px;font-family:Georgia,serif}
   #wlhelp h3{font-weight:normal;margin:0 0 2px;font-size:1.15rem}
   #wlhelp .q{font:10px Helvetica;letter-spacing:.16em;text-transform:uppercase;color:#425934;margin:16px 0 7px}
   #wlhelp .opts{display:flex;flex-wrap:wrap;gap:7px}
   #wlhelp .op{border:1px solid #d8d3cb;background:#fff;border-radius:999px;padding:6px 14px;font:11.5px Helvetica;color:#444;cursor:pointer}
   #wlhelp .op.on{border-color:#1b1b1b;background:#1b1b1b;color:#fff}
   #wlhelp .hdot{width:20px;height:20px;border-radius:50%;border:2px solid #fff;outline:1px solid #ddd;cursor:pointer;padding:0}
   #wlhelp .hdot.on{outline:2px solid #1b1b1b}
   #wlhelp .foot{display:flex;gap:12px;align-items:center;margin-top:22px}
   /* ≤700px — Summer 2026-07-13. Placed LAST in the sheet on purpose: the base
      .cam/.hmc/.go/#wlhead h2 rules sit earlier, so a mobile block placed before
      them would lose the padding/size battle by source order. Goals: search stays
      ONE row like desktop (input+📷+Help+Art Search); smaller dropdowns
      (theme forces select 16px !important → these need !important); heading fits;
      product titles clamp to the first line only. */
   @media (max-width:700px){
     #wlhead{padding:16px 16px 2px}
     #wlhead h2{font-size:1.3rem;line-height:1.25}
     /* no sub-line at all on a phone (Summer 2026-09-07) - the heading and the
        box itself already say what to do, and it cost two lines above the fold */
     #wlhead .sub{display:none}
     /* one line, always (Summer 2026-09-02): bar + Source share the row on a
        phone — nowrap + tighter paddings buy the width back */
     #wlb .row{flex-wrap:nowrap;gap:6px;padding:12px 10px 4px}
     #wlb .srch{flex:1 1 auto;min-width:0}
     #wlb .srch{flex-wrap:nowrap}
     #wlb .srch input{flex:1 1 auto;min-width:0;padding:11px 10px}
     #wlb .cam{flex:0 0 auto;padding:0 5px}
     #wlb .hmc{flex:0 0 auto;padding:0 6px;letter-spacing:.02em}
     /* 2026-09-02: buttons renamed Help / Source / Search everywhere (Summer's
        redesign) — the old phone-only "Help me choose" truncation rule is gone
        because the long label is gone. */
     #wlb .go{flex:0 0 auto;padding:0 9px;font-size:12px;letter-spacing:.02em;display:flex;align-items:center;white-space:nowrap}
     /* count + sourcing offer share ONE line with the grid icons, right side
        (Summer 2026-09-02): stripHome wraps the icon switch + this zone in ONE
        flex row (#wltbrow) — deterministic, whatever the theme toolbar does */
     #wltbrow #wlzl{justify-content:flex-end !important;padding:0 !important}
     /* Summer 2026-09-07: it was ellipsised away on a phone. Smaller, and allowed
        to use a second line, so the whole "Matches for … — 40 artworks" is readable */
     #wltbrow #wlcount, #wlcount{display:flex;align-items:center;justify-content:flex-end;gap:8px;
       min-width:0;font-size:9px !important;letter-spacing:.03em;white-space:normal;line-height:1.35;text-align:right}
     #wlcountlab{overflow:visible;text-overflow:clip;white-space:normal;min-width:0;flex:0 1 auto}
     #wlcount #wlsrcline{margin-left:0 !important}
     #wlsrcline .wlsrcpre{display:none}
     /* PHONE ROWS, full width (Summer 2026-09-07). The dropdowns share the row
        three and three, so Ratio and Sort sit together on the second line instead
        of hanging alone. Widths are shared, not measured — fitSel's pixel width is
        overridden here on purpose. */
     /* ALL SIX on ONE row (Summer 2026-09-07). The six words measure 225px at 10px;
        the native dropdown arrow costs ~16px each, so it is replaced by a drawn
        caret. Sized with REAL headroom, not to the pixel: at 10px it measured 348
        of 359 and still wrapped on a slow load, so 9.5px leaves ~30px spare. */
     #wlb .wlchips-dd{padding:0 8px;gap:3px;justify-content:flex-start;flex-wrap:wrap;max-width:100%}
     /* each chip keeps the exact width fitSel measured for the word showing —
        flex must NOT squeeze them, that is what cut "EDITI" and "SHA" */
     #wlb .wlchips-dd select{flex:1 0 auto;max-width:none !important;min-width:0;font-size:9.5px !important;
       padding:6px 12px 6px 3px !important;height:auto !important;line-height:1.3 !important;
       border-radius:0 !important;text-align:center;text-align-last:center;
       -webkit-appearance:none;appearance:none;
       background-image:linear-gradient(45deg,transparent 50%,#777 50%),linear-gradient(135deg,#777 50%,transparent 50%);
       background-position:calc(100% - 8px) 52%,calc(100% - 4px) 52%;
       background-size:4px 4px,4px 4px;background-repeat:no-repeat}
     #wlb select{border-radius:0 !important}
     /* colour line, ONE row (Summer 2026-09-07). 15 dots at 18px plus ALL need
        344px of the 355 a 375px phone has — they only fit once the word "colour"
        steps aside. Every dot still names its colour on touch-and-hold. */
     #wlb #wlchip-lab{display:none}
     #wlb .wlchips-co{gap:4px;padding:0 10px;justify-content:flex-start;flex-wrap:wrap;align-items:center;max-width:100%}
     #wlb .wldots{flex:1 1 auto;min-width:0;gap:2px;flex-wrap:wrap;justify-content:space-between}
     #wlb .dot{width:17px;height:17px;flex:none}
     #wlb .alla{padding:5px 9px;margin-left:auto;flex:none}
     product-card .product-title{display:flex !important;align-items:baseline;gap:6px;white-space:nowrap;overflow:hidden !important;min-width:0}
   }
  </style>
  <div id="wlb">
   <div id="wlhead">
    <h2>Custom Oversize Art</h2>
    <p class="sub">Type a colour, room, mood or artist. <span class="sub2">Or upload a photo of an artwork you love.</span></p>
   </div>
   <div class="row"><div class="srch">
    <input id="wlq" maxlength="200" placeholder="Type a colour, room, mood, style or artist">
    <button class="cam" id="wlcam" title="Upload a photo of an artwork — we find the same piece or its closest matches">📷</button>
    <button class="hmc" id="wlhmc" title="A few quick questions — we narrow the collection to your best matches">Help</button>
    <button class="go" id="wlgo">Search</button>
    <div id="wlprog" aria-hidden="true"><i></i></div></div>
    <button class="go" id="wlsrcbtn" title="Can't find it? Send the artist, title or a picture and we find it for you, free">Find art</button></div>
   <div class="echo" id="wlecho"></div>
   <div class="chips" id="wlchips"></div>
   <!-- Papers & Fabrics · Wall Murals stay UNLINKED until tested (Summer 2026-07-12) -->
   <div class="panel" id="wlpanel"></div>
  </div>
  <button id="wlcartchip"></button>
  <div id="wlqv"></div>
  <div id="wlgrid"></div>
  <div id="wlhelpov"><div id="wlhelp"></div></div>
  <div id="wlov"><div class="hd"><b>WALL : LIBERATION — THE STUDIO</b><button id="wlx">Close ✕</button></div>
  <iframe id="wlfr" allow="clipboard-write" src="about:blank"></iframe></div>`;

  // product pages carry their own tools (customiser, saved strip, sets) — no search bar
  if (IS_PDP) document.getElementById("wlb").style.display = "none";
  if (IS_HOME) document.getElementById("wlhead").style.display = "none";   // the hero is the heading on home

  // ---- adopt the theme's typography so the bar is family, not a guest ----
  (function adoptTheme(){
    const body = getComputedStyle(document.body);
    const btnBg = "#425934", btnFg = "#fff";   // deep warm green — Summer's call, never theme-sampled
    document.documentElement.style.setProperty("--wlbtn", btnBg);
    document.documentElement.style.setProperty("--wlbtnfg", btnFg);
    const h = document.querySelector("h1,h2,.heading,[class*='heading']");
    const head = h ? getComputedStyle(h).fontFamily : body.fontFamily;
    const st = document.createElement("style");
    st.textContent = `
     #wlb, #wlb *, #wlqv, #wlqv *, .wlsel, #wlcartchip, .wltbstrip, .wltbstrip *, #wlcount, #wlhelp, #wlhelp * { font-family: ${body.fontFamily} !important; }
     #wlqv h3, #wlhead h2, #wlhelp h3 { font-family: ${head} !important; letter-spacing:.02em }
     #wlb input, #wlb input:focus, #wlb input:focus-visible { font-size:.9rem !important; border:none !important; box-shadow:none !important; background:#fff !important; outline:none !important }
     #wlb .srch:focus-within { outline:none !important; box-shadow:none !important }
     #wlb .go, #wlb .btn { letter-spacing:.16em; text-transform:uppercase; font-size:10px !important }
     #wlb .echo, #wlb .panel { color:#6b6b6b }
     #wlb { border:none; box-shadow:none }
     #wlb .srch { border-color:#1b1b1b }
     .wlsel { border-radius:0; letter-spacing:.12em; text-transform:uppercase; font-size:9.5px !important }
     #wlb .chip, #wlhelp .op { border-radius:0; letter-spacing:.1em; text-transform:uppercase; font-size:9.5px !important }
     /* made-to-order variants exist for checkout only — never as picker choices */
     [data-value-handle*="made-to-order"], .block-swatch[data-value-handle*="made-to-order"] { display:none !important }`;
    document.head.appendChild(st);
  })();

  // ================= THE STUDIO OVERLAY (cart + full app, opened by the chip) =====
  const ov = document.getElementById("wlov"), fr = document.getElementById("wlfr");
  function openStudio(tab, q) {
    let u = "/apps/studio?embed=1";              // own-domain App Proxy (same-origin: storage + messages shared)
    if (tab) u += "&tab=" + encodeURIComponent(tab);
    if (q) u += "&q=" + encodeURIComponent(q);
    fr.src = u;
    ov.style.display = "flex";
    document.documentElement.style.overflow = "hidden";
    fr.onload = () => { try {
      fr.contentWindow.postMessage({ wlInit: { sel: S.sel, pending: S.pending, email: S.email } }, "*");
      S.pending = []; savePending(); cartCount();
    } catch (e) {} };
  }
  function closeStudio() { ov.style.display = "none"; fr.src = "about:blank"; document.documentElement.style.overflow = ""; }
  document.getElementById("wlx").onclick = closeStudio;
  document.addEventListener("keydown", e => { if (e.key === "Escape") { closeStudio(); helpClose(); } });
  window.addEventListener("message", e => { try {
    if (e.origin !== API && e.origin !== location.origin) return;
    if (e.data && e.data.wlCart) { S.studioCount = e.data.wlCart.count;
      try { localStorage.wl_studio_count = S.studioCount; } catch (err) {} cartCount(); }
    if (e.data && e.data.wlSel) { S.sel = e.data.wlSel.sel || S.sel;
      try { localStorage.wl_selected = JSON.stringify(S.sel); } catch (err) {}
      strip(); refreshPills(); }
  } catch (err) {} });
  // the old Studio cart chip is retired — the native Shopify cart owns everything
  const chip = document.getElementById("wlcartchip");
  chip.style.display = "none";
  // Summer 2026-07-31: the header cart badge is written by wl_search.js, which
  // ships with the header on EVERY page — this module only loads on artwork
  // pages, so owning the badge here left the homepage with an empty green circle.
  // cartCount() stays as the call site every cart flow already uses; it just
  // rings the bell the header module listens for.
  const cartCount = () => { try {
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  } catch (e) {} };
  try { localStorage.wl_studio_count = 0; localStorage.wl_pending = "[]"; } catch (e) {}
  window.WLBar = { openStudio, cards: () => S.cards, sel: () => S.sel };   // for the PDP modules

  // ---- NATIVE cart add ----
  async function nativeAddLine(line) {
    const r = await api("/api/native-line", line);
    if (!r || !r.ok) throw new Error((r && r.message) || "could not prepare the item");
    const cr = await fetch("/cart/add.js", { method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ items: [{ id: r.variantId, quantity: line.qty || 1, properties: r.properties || {} }] }) });
    if (!cr.ok) throw new Error("cart add failed");
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", { bubbles: true }));
    const c = await fetch("/cart.js").then(x => x.json());
    const ic = document.querySelector("a[href='/cart'] .cart-count, .cart-count-bubble, [class*='cart-count']");
    if (ic) ic.textContent = c.item_count;
    return c.item_count;
  }
  window.addEventListener("message", e => { try {
    if ((e.origin !== API && e.origin !== location.origin) || !e.data || !e.data.wlNativeCheckout) return;
    (async () => {
      for (const l of (e.data.wlNativeCheckout.lines || [])) {
        try {
          await nativeAddLine({
            kind: l.type === "mural" ? "mural" : ((l.recipe || {}).own_artwork ? "own" : "artwork"),
            index: l.index, w: l.w, h: l.h, framing: l.framing || "rolled",
            substrate: l.substrate || "canvas", look: (l.recipe || {}).colour_look || "natural",
            unit_override: (l.adjusted_unit || l.unit_price) + (l.surcharge || 0),
            qty: l.qty || 1, indices: (l.recipe || {}).indices, mood: (l.recipe || {}).mood,
            moods: (l.recipe || {}).moods, material: (l.recipe || {}).material,
            panel_width: (l.recipe || {}).panel_width, offset: (l.recipe || {}).offset,
            own_ref: (l.recipe || {}).own_art_ref, own_url: l.own_art_url });
        } catch (err) { console.warn("wl native line:", err); }
      }
      try { fr.contentWindow.postMessage({ wlNativeDone: true }, "*"); } catch (err) {}
      S.studioCount = 0; try { localStorage.wl_studio_count = 0; } catch (err) {} cartCount();
      setTimeout(() => { location.href = "/cart"; }, 500);
    })();
  } catch (err) {} });

  // ================= last-search persistence (R1) =================
  function saveLast() { try {
    localStorage.wl_last_search = JSON.stringify({ q: (document.getElementById("wlq") || {}).value || "",
      chip: CHIP, url: location.href.split("#")[0], y: window.scrollY, t: Date.now() });
  } catch (e) {} }
  function lastSearch() { try { return JSON.parse(localStorage.wl_last_search || "null"); } catch (e) { return null; } }

  // ================= PDP: zoom into the print (Summer 2026-09-06) =================
  // Shown ONLY when the artwork has a Wonder master on the server: the worker
  // answers /tiles/<index>/info.json. Tiles are cut from the Wonder master at
  // half its size — buyers see the print's real detail, never a printable file.
  // OpenSeadragon loads on the first click only, so the page weight is unchanged.
  function mountZoom(c, acts, skin) { try {
    if (!c || !c.index || document.getElementById("wlzoombtn")) return;
    const cands = [String(c.index), String(c.index).replace(/[A-Z]$/, ""), String(c.index).replace(/[A-Z]$/, "") + "N"]
      .filter((v, i, a) => v && a.indexOf(v) === i);
    let info = null, idx = null;
    (async () => {
      for (const k of cands) {
        try { const r = await fetch(API + "/tiles/" + k + "/info.json", { cache: "no-cache" });
          if (r.ok) { const j = await r.json(); if (j && j.verified !== false) { info = j; idx = k; break; } } } catch (e) {}
      }
      if (!info) return;
      const b = document.createElement("button");
      b.id = "wlzoombtn"; b.type = "button"; b.textContent = "⌕ Zoom in";
      b.title = "See the real detail of this print, up close";
      b.onclick = () => openZoom(idx, info, c);
      // Summer 2026-09-07 ("where?? zoom in"): the button lives in the
      // room-view tab row (Demo room · My room (photo-real = last step of My room; zoom is its own section)), right
      // above the artwork — not in the breadcrumb row. Falls back to the
      // action row only if the customiser never mounts.
      let tries = 0;
      const place = () => {
        const tabs = document.querySelector(".wtabs");
        if (tabs) {
          b.className = "wt";
          const spacer = tabs.querySelector("span[style*='flex:1']");
          tabs.insertBefore(b, spacer || null);
        } else if (++tries < 40) {
          setTimeout(place, 250);
        } else {
          b.style.cssText = skin; acts.appendChild(b);
        }
      };
      place();
      try { wlPing("zoom_offered", { i: c.index }); } catch (e) {}
    })();
  } catch (e) {} }
  function openZoom(idx, info, c) {
    let ov = document.getElementById("wlzoomov");
    if (!ov) {
      ov = document.createElement("div"); ov.id = "wlzoomov";
      ov.style.cssText = "position:fixed;inset:0;z-index:2147483000;background:#111;display:flex;flex-direction:column";
      ov.innerHTML = '<div style="display:flex;align-items:center;gap:12px;padding:10px 14px;background:#fff;color:#1b1b1b;' +
        'font:12px Helvetica,Arial;letter-spacing:.06em;text-transform:uppercase"><span style="font:600 15px Fraunces,Georgia,serif;' +
        'text-transform:none;letter-spacing:0;flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"></span>' +
        '<span id="wlzoomhint" style="color:#666;text-transform:none;letter-spacing:0">Pinch or scroll to zoom · drag to move</span>' +
        '<button type="button" id="wlzoomx" style="background:#fff;border:1px solid #1b1b1b;color:#1b1b1b;cursor:pointer;font-size:12px;padding:7px 14px">Close</button></div>' +
        '<div id="wlzoomv" style="flex:1;min-height:0"></div>';
      document.body.appendChild(ov);
      ov.querySelector("#wlzoomx").onclick = () => { ov.style.display = "none"; document.body.style.overflow = ""; };
      document.addEventListener("keydown", e => { if (e.key === "Escape" && ov.style.display !== "none") ov.querySelector("#wlzoomx").click(); });
    }
    ov.querySelector("span").textContent = (c && c.title) || "";
    ov.style.display = "flex"; document.body.style.overflow = "hidden";
    const start = () => {
      const v = document.getElementById("wlzoomv");
      if (v.dataset.idx === idx) return;
      v.innerHTML = ""; v.dataset.idx = idx;
      OpenSeadragon({ element: v, prefixUrl: "", showNavigationControl: false, showNavigator: false,
        gestureSettingsMouse: { clickToZoom: false, dblClickToZoom: true, scrollToZoom: true },
        gestureSettingsTouch: { pinchToZoom: true, flickEnabled: true },
        minZoomImageRatio: 0.6, maxZoomPixelRatio: 1.2, visibilityRatio: 0.8, animationTime: 0.6,
        tileSources: { width: info.width, height: info.height, tileSize: info.tileSize, tileOverlap: 0,
          minLevel: 0, maxLevel: info.levels - 1,
          getTileUrl: (level, x, y) => API + "/tiles/" + idx + "/" + (info.prefix ? info.prefix + "/" : "") + level + "/" + x + "_" + y + ".jpg" } });
      try { wlPing("zoom_open", { i: idx }); } catch (e) {}
    };
    if (window.OpenSeadragon) start();
    else { const s = document.createElement("script");
      s.src = "https://cdnjs.cloudflare.com/ajax/libs/openseadragon/4.1.1/openseadragon.min.js";
      s.onload = start; s.onerror = () => { document.getElementById("wlzoomhint").textContent = "The zoom viewer could not load — please try again."; };
      document.head.appendChild(s); }
  }

  // ================= PDP: saved strip in the share section + back link (R1) ======
  function mountPdp(pageCard) { try {
    if (!IS_PDP || document.getElementById("wlpdpmount")) return;
    const h = location.pathname.split("/products/")[1].split("?")[0].split("/")[0];
    if (h === "print-stretch-and-frame-your-own-art") {   // Print-Your-Own (2026-07-23)
      const f0 = document.querySelector("form[action*='/cart/add']");
      const host0 = f0 ? (f0.closest("[class*='product-info'],[class*='product__info']") || f0.parentElement)
                       : (document.getElementById("MainContent") || document.body);
      const hd = document.createElement("div"); hd.id = "wlpdpmount";
      host0.appendChild(hd);
      // finally, ALWAYS: a throw part-way through mount() used to leave the cover
      // holding forever, because the rescue below keys on this holder being
      // absent and it is appended before mount runs. The file loaded fine, so no
      // error event fires either — the visitor got "Something went wrong" on a
      // page that half built. Reveal what we have instead. (audit 2026-08-24)
      try { if (window.WLC) WLC.mount(hd, { ownArt: true, cards: S.cards }); }
      finally { document.body.classList.add("wl-c-ready"); }
      return;
    }
    // 2026-09-24: an artwork page brings its own card (window.__wlCard from
    // sections/wl-studio-bar.liquid), so the build no longer waits for the 104 KB
    // library. The library path below stays for any page without one.
    let c = pageCard || null;
    if (!c) {
      if (!Object.keys(H2I).length) for (const c0 of S.cards) if (c0.url) { const m = c0.url.match(/\/products\/([a-z0-9-]+)/); if (m) H2I[m[1]] = c0.index; }
      const i = H2I[h]; c = i && byI(i);
    }
    if (!c) return;
    const form = document.querySelector("form[action*='/cart/add']");
    const host = form ? (form.closest("[class*='product-info'],[class*='product__info']") || form.parentElement)
                      : (document.getElementById("MainContent") || document.body);
    const holder = document.createElement("div"); holder.id = "wlpdpmount";
    host.appendChild(holder);
    // finally, ALWAYS — see the same guard on the print branch above (2026-08-24)
    try { if (window.WLC) WLC.mount(holder, { card: c, cards: S.cards }); }
    finally { document.body.classList.add("wl-c-ready"); }
    // saved strip lives IN the breadcrumb bar, centered
    const crumb0 = document.querySelector("nav[aria-label*='readcrumb'], .breadcrumb, [class*='breadcrumb']");
    let sHost = null;
    if (crumb0) {
      crumb0.style.display = "flex"; crumb0.style.alignItems = "center"; crumb0.style.flexWrap = "wrap";
      sHost = document.createElement("span");
      sHost.className = "wlpdp-shost";
      sHost.style.cssText = "flex:1;display:flex;justify-content:center;min-width:0";
      crumb0.appendChild(sHost);
    }
    if (!sHost) sHost = document.getElementById("wlpdptop") ||
      document.querySelector('[data-block-type="share-buttons"]') || holder;
    const box = document.createElement("div");
    box.id = "wlpdpstrip";
    box.style.cssText = "margin:4px 0 8px;max-width:100%";
    const last = lastSearch();
    const render = () => {
      box.innerHTML = `<span class="wltbstrip" style="margin-left:0;position:relative">` +
        (S.sel.length ? savedHtml() : `<span class="lbl" style="color:#999">Saved (0)</span>`) + `</span>`;
      if (S.sel.length) wireSaved(box, render);
    };
    // WL 2026-07-31 (Summer): saved strip removed from the PDP breadcrumb — the
    // header heart (with count) + View-all-saved covers it. box stays DETACHED so
    // render()/wireSaved keep working for the Save button beside it.
    render();
    // "Back to your search" lives at the TOP — right-aligned on the breadcrumb line
    const goBack = () => { try { localStorage.wl_restore = "1"; } catch (e) {}
      location.href = (last && last.url) || "/collections/all"; };
    const crumb = document.querySelector("nav[aria-label*='readcrumb'], .breadcrumb, [class*='breadcrumb']");
    const backBtn = document.createElement("button");
    backBtn.id = "wlback";
    backBtn.textContent = "← Back to search";
    backBtn.style.cssText = "background:#fff;border:1px solid #1b1b1b;color:#1b1b1b;cursor:pointer;" +
      "font-size:12px;padding:7px 14px;margin-right:24px;white-space:nowrap;font-family:" +
      getComputedStyle(document.body).fontFamily;
    backBtn.onclick = goBack;
    // Summer 2026-07-15: Back + Save + Share ride the SAME top row, both breakpoints.
    const acts = document.createElement("span");
    acts.id = "wlacts";
    acts.style.cssText = "display:flex;align-items:center;gap:8px;margin-right:24px";
    backBtn.style.marginRight = "0";
    acts.appendChild(backBtn);
    // Save this artwork right here — the strip only ever showed the count
    const saveBtn = document.createElement("button");
    saveBtn.id = "wlsavepdp"; saveBtn.type = "button";
    saveBtn.style.cssText = backBtn.style.cssText;   // same skin as Back
    const syncSave = () => { const on = S.sel.includes(c.index);
      saveBtn.textContent = on ? "✓ Saved" : "♡ Save";
      saveBtn.style.background = on ? (getComputedStyle(document.body).getPropertyValue("--wlbtn") || "#425934") : "#fff";
      saveBtn.style.color = on ? "#fff" : "#1b1b1b";
      saveBtn.style.borderColor = on ? saveBtn.style.background : "#1b1b1b"; };
    saveBtn.onclick = () => {
      const k = S.sel.indexOf(c.index);
      if (k < 0 && S.sel.length >= SAVED_MAX) {
        const e0 = document.getElementById("wlecho");
        if (e0) e0.textContent = "Saved is full (30) — remove one to add more.";
        return; }
      if (k >= 0) S.sel.splice(k, 1); else { S.sel.push(c.index); S.active = c.index; wlPing("save", { ix: c.index }); }
      try { localStorage.wl_selected = JSON.stringify(S.sel); } catch (e) {}
      syncSave(); render();          // refresh the Saved (n) strip beside it
    };
    syncSave();
    acts.appendChild(saveBtn);
    // zoom lives in the customiser's room-view tabs since 2026-09-07 (Detail zoom)
    // Share reads as a BUTTON like Save (Summer 2026-07-15), not a row of icons.
    // The theme's own share block still does the work — it just moves off-screen
    // and this button opens it (native sheet where the device has one).
    const shareBtn = document.createElement("button");
    shareBtn.id = "wlsharebtn"; shareBtn.type = "button";
    shareBtn.style.cssText = backBtn.style.cssText;
    shareBtn.textContent = "↗ Share";
    shareBtn.onclick = async () => {
      const url = location.href.split("#")[0];
      if (navigator.share) { try { await navigator.share({ title: document.title, url }); return; } catch (e) { return; } }
      const native = document.querySelector('#wlsharetop .share-buttons--native');
      if (native && !native.hidden) { native.click(); return; }
      try { await navigator.clipboard.writeText(url); shareBtn.textContent = "✓ Link copied";
        setTimeout(() => { shareBtn.textContent = "↗ Share"; }, 1800); } catch (e) {}
    };
    acts.appendChild(shareBtn);
    // keep the theme block in the DOM (it powers the native sheet) but out of sight
    const mvShare = () => { const sb = document.querySelector('[data-block-type="share-buttons"]');
      if (!sb || sb.id === "wlsharetop") return !!sb;
      sb.id = "wlsharetop"; sb.style.display = "none"; return true; };
    if (!mvShare()) { let n = 0; const iv = setInterval(() => {
      if (mvShare() || ++n > 25) clearInterval(iv); }, 150); }
    if (crumb) {
      crumb.style.display = "flex"; crumb.style.alignItems = "center";
      crumb.appendChild(acts);
    } else {
      const main = document.getElementById("MainContent") || document.querySelector("main");
      const row = document.createElement("div");
      row.style.cssText = "display:flex;justify-content:flex-end;padding:8px 20px 0";
      row.appendChild(acts);
      if (main) main.insertBefore(row, main.firstChild);
    }
    const scrub = () => document.querySelectorAll("select option").forEach(o => {
      if (o.textContent.includes("— made to order") && !o.selected) o.remove(); });
    scrub(); setInterval(scrub, 1500);
    mountStickyAtc();
  } catch (err) { console.warn("wl pdp:", err); } }
  // Mobile sticky Add-to-Cart: appears once the real button scrolls out of view,
  // mirrors the live price and simply clicks the real ATC (so it can never break
  // checkout — it drives the existing form).
  // Summer 2026-07-15: the chat bubble floats bottom-right and blocks the view.
  // Shopify's agent widget lives in a shadow DOM but exposes part="activator", so
  // we can drive it from a header icon and retire the bubble. Only ever hide the
  // bubble once we KNOW our icon can open it — otherwise chat becomes unreachable.
  function chatInHeader() {
    // 2026-07-30: Shopify renamed the widget element shopify-agent -> shopify-chat; match both
    const ag = document.querySelector("shopify-agent, shopify-chat");
    const act = ag && ag.shadowRoot && ag.shadowRoot.querySelector('[part="activator"]');
    if (!act) return false;
    if (document.getElementById("wlchat")) return true;
    const searchLi = document.querySelector("li.header__search-link");
    const cartLi = document.querySelector("li.header__cart-link");
    const host = (searchLi || cartLi) && (searchLi || cartLi).parentElement;
    if (!host) return false;
    const li = document.createElement("li");
    li.id = "wlchat";
    li.className = (searchLi ? searchLi.className.replace("header__search-link", "") : "").trim();
    li.innerHTML = '<a href="#" role="button" aria-label="Chat with us" ' +
      'style="display:flex;align-items:center;color:inherit">' +
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 8.5 8.5 0 0 1-3.9-.9L3 21l1.9-5.1A8.4 8.4 0 0 1 12 3a8.4 8.4 0 0 1 9 8.5z"/>' +
      "</svg></a>";
    li.querySelector("a").onclick = e => { e.preventDefault();
      const a = ag.shadowRoot.querySelector('[part="activator"]'); if (a) a.click(); };
    host.insertBefore(li, cartLi || null);
    // Retire the bubble. ::part() alone is not enough — the widget re-renders its
    // activator (and can nest it a shadow level deeper, which ::part cannot reach),
    // so hide the element itself and re-hide it whenever the app rebuilds.
    const s = document.createElement("style");
    s.textContent = "shopify-agent::part(activator),shopify-chat::part(activator){display:none !important}";
    document.head.appendChild(s);
    const hideBubble = () => ag.shadowRoot.querySelectorAll('[part="activator"], .activator, .activator-nudge')
      .forEach(el => el.style.setProperty("display", "none", "important"));
    hideBubble();
    try { new MutationObserver(hideBubble).observe(ag.shadowRoot, { childList: true, subtree: true }); } catch (e) {}
    return true;
  }

  function mountStickyAtc() { try {
    if (!IS_PDP || document.getElementById("wlstickyatc")) return;
    const atc = document.querySelector("button[name='add'], .product-form__submit, buy-buttons button, form[action*='/cart/add'] button[type='submit']");
    if (!atc) return;
    // Re-query every sync: the buy-box price hydrates late and the customiser
    // rewrites it. Scope it tightly — a loose [class*='price-list'] fallback
    // matched a RELATED-PRODUCT card and mirrored "From $403" onto a $1,615 work.
    const findPrice = () => document.querySelector(".price-list--product") ||
                            document.querySelector("product-sticky-bar .price-list");
    const st = document.createElement("style");
    st.textContent = `
     #wlstickyatc{position:fixed;left:0;right:0;bottom:0;z-index:60;display:none;align-items:center;gap:10px;padding:9px 14px calc(9px + env(safe-area-inset-bottom,0px));background:#fff;border-top:1px solid #e6e2dc;box-shadow:0 -4px 18px rgba(0,0,0,.10);font-family:${getComputedStyle(document.body).fontFamily}}
     #wlstickyatc.on{display:flex}
     #wlstickyatc .wlsa-p{flex:1;min-width:0;font-size:15px;font-weight:600;color:#425934;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
     #wlstickyatc .wlsa-b{flex:0 0 auto;background:var(--wlbtn,#425934);color:#fff;border:none;padding:13px 22px;font:10px Helvetica;letter-spacing:.14em;text-transform:uppercase;cursor:pointer}
     #wlstickyatc .wlsa-t{flex:0 0 auto;width:34px;height:34px;padding:0;display:flex;align-items:center;justify-content:center;background:#f4f2ee;border:1px solid #e0dbd2;border-radius:50%;cursor:pointer;color:#1b1b1b}
     #wlstickyatc .wlsa-t svg{width:15px;height:15px;display:block}
     @media(min-width:750px){#wlstickyatc{display:none !important}}`;
    document.head.appendChild(st);
    const bar = document.createElement("div");
    bar.id = "wlstickyatc";
    // back-to-top sits to the RIGHT of Add to cart (Summer 2026-07-15)
    bar.innerHTML =
      `<span class="wlsa-p"></span><button class="wlsa-b" type="button">Add to cart</button>` +
      `<button class="wlsa-t" type="button" aria-label="Back to top">` +
      `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">` +
      `<path d="M12 19V5"/><path d="M5 12l7-7 7 7"/></svg></button>`;
    document.body.appendChild(bar);
    const p = bar.querySelector(".wlsa-p");
    const atcSel = "button[name='add'], .product-form__submit, buy-buttons button, form[action*='/cart/add'] button[type='submit']";
    const sync = () => { const el = findPrice(); if (!el) return;
      // Read the SALE PRICE element's own text, with the screen-reader label and
      // the Afterpay line stripped out. It used to grab the first "$" amount in
      // the block, which on any non-dollar market skipped "€196,95 EUR" (no $)
      // and picked up the hidden Afterpay figure instead — a Vienna phone showed
      // "$4,923.75 Aft" beside ADD TO CART for a €196,95 print, 25x the real
      // price in the wrong currency (Summer 2026-08-23).
      const src = el.querySelector("sale-price") || el;
      const cl = src.cloneNode(true);
      cl.querySelectorAll(".sr-only, .wl-afterpay-msg, [class*='afterpay']")
        .forEach(n => n.remove());
      const txt = (cl.textContent || "").replace(/\s+/g, " ")
        .replace(/\(or 4 payments[^)]*\)?/i, "").trim();
      if (txt) p.textContent = txt; };
    sync();
    // The buy box first renders the DEFAULT variant, then the picker/customiser
    // rewrite it to the selected one. Without this the bar froze on the cheapest
    // variant's price ($647 on a $1,615 work) until the first scroll.
    let raf = 0;
    const syncSoon = () => { if (raf) return;
      raf = requestAnimationFrame(() => { raf = 0; sync(); }); };
    new MutationObserver(syncSoon).observe(document.querySelector(".product-info") || document.body,
      { subtree: true, childList: true, characterData: true });
    // Tap feedback (Summer 2026-07-31): the real button says "Adding… / ✓ Added"
    // but sits off-screen whenever this bar is up, so mobile saw nothing. Mirror
    // the real button's text here; the theme-native path (pure default variant)
    // changes no button text, so a /cart/add fetch watch + cart events cover it.
    const sb = bar.querySelector(".wlsa-b");
    let sbBusy = false, sbWatch = null, sbGuard = 0;
    const sbEnd = ok => { if (!sbBusy) return; sbBusy = false;
      if (sbWatch) { sbWatch.disconnect(); sbWatch = null; }
      clearTimeout(sbGuard);
      if (ok) { sb.textContent = "✓ Added — in your cart";
        setTimeout(() => { sb.textContent = "Add to cart"; sb.disabled = false; }, 2600); }
      else { sb.textContent = "Add to cart"; sb.disabled = false; } };
    ["cart:refresh", "cart:change", "cart:updated", "variant:added"].forEach(ev =>
      document.addEventListener(ev, () => sbEnd(true)));
    const sbFetch = window.fetch;
    window.fetch = function (u) { const p = sbFetch.apply(this, arguments);
      const url = String((u && u.url) || u || "");
      if (sbBusy && url.includes("/cart/add"))
        p.then(r => { if (r && r.ok) sbEnd(true); }, () => sbEnd(false));
      return p; };
    sb.onclick = () => { const a = document.querySelector(atcSel); if (!a) return;
      const base = (a.textContent || "").trim();
      sbBusy = true; sb.disabled = true; sb.textContent = "Adding…";
      sbGuard = setTimeout(() => sbEnd(false), 15000);   // silent revert — covers blocked adds (e.g. missing upload)
      sbWatch = new MutationObserver(() => { const t = (a.textContent || "").trim();
        if (t.indexOf("✓") === 0) sbEnd(true);
        else if (t === base) sbEnd(false);               // customiser reverted — error path
        else if (t) sb.textContent = t; });              // "Adding…", "Adding the set…"
      sbWatch.observe(a, { childList: true, characterData: true, subtree: true });
      a.click(); };
    bar.querySelector(".wlsa-t").onclick = () => window.scrollTo({ top: 0, behavior: "smooth" });
    const check = () => { sync(); const a = document.querySelector(atcSel); if (!a) return; const r = a.getBoundingClientRect();
      bar.classList.toggle("on", r.height > 0 && (r.bottom < 40 || r.top > window.innerHeight)); };
    window.addEventListener("scroll", check, { passive: true }); window.addEventListener("resize", check); check();
  } catch (err) { console.warn("wl sticky atc:", err); } }
  function addPending(line) { S.pending.push(line); savePending(); cartCount();
    const el = document.getElementById("wlecho");
    el.innerHTML = `Added to your cart · <button class="lnk" id="wlopencart">open the cart to check out</button>`;
    el.querySelector("#wlopencart").onclick = () => openStudio(null, ""); }

  // ================= selection strip — PAGE BODY only (R1) =================
  function refreshPills() {
    document.querySelectorAll("[data-wl]").forEach(cd => {
      const p = cd.querySelector(".wlsel"); if (!p) return;
      const on = S.sel.includes(cd.dataset.wl);
      p.classList.toggle("on", on); p.innerHTML = on ? "✓ Saved" : "Save"; });
  }
  let COUNT0 = "", LASTLAB = null, SRCQ = null;   // SRCQ: query of a closest-match search
  function setCount(n, label) {
    // the toolbar can hold both arrangements (#wlstriprow and #wltbrow), so more than
    // one #wlcount can exist. Only the first is shown; the spares are kept in step but
    // hidden, so "372 products" can never sit under "… — 40 artworks" again.
    const all = document.querySelectorAll('[id="wlcount"]');
    all.forEach((e, k) => { if (k) e.style.display = "none"; });
    const el = all[0]; if (!el) return;
    if (n == null) { LASTLAB = null; SRCQ = null; }  // cleared — the breadcrumb may come back
    // label lives in its own span so the phone can ellipsis it to ONE line
    // beside the grid icons (Summer 2026-09-02)
    el.textContent = "";
    const lab = document.createElement("span");
    lab.id = "wlcountlab";
    lab.textContent = n == null ? (COUNT0 || "")
      : (label ? label + " — " : "") + n + (n === 1 ? " artwork" : " artworks");
    el.appendChild(lab);
    // closest-match searches carry the sourcing offer RIGHT OF the count line
    // — re-appended here so sort/view re-renders keep it
    if (n != null && SRCQ != null && window.WLAsk) {
      const b = document.createElement("button");
      b.id = "wlsrcline";
      b.style.cssText = "font:inherit;background:none;border:none;padding:0;margin-left:14px;" +
        "color:inherit;text-decoration:underline;text-underline-offset:3px;cursor:pointer;flex:none";
      b.innerHTML = '<span class="wlsrcpre">Can’t find it? </span>We’ll find it for you, free';
      const qq = SRCQ;
      b.onclick = () => window.WLAsk.open(qq);
      el.appendChild(b);
    }
    const zl = document.getElementById("wlzl");
    if (zl) adoptCrumb(zl, el);
    // the count width changed — re-window the saved strip so it stays beside it
    clearTimeout(window.__wlcw);
    window.__wlcw = setTimeout(() => { if (document.getElementById("wlstriprow")) strip(); }, 80);
  }
  // the collection breadcrumb moves into zone L; a live search replaces it with
  // the "Matches for …" text (Summer: both never together — the search supersedes
  // the collection context)
  function adoptCrumb(zl, before) {
    const c = document.querySelector("nav[aria-label*='readcrumb'], .breadcrumb, [class*='breadcrumb']");
    if (c && !zl.contains(c)) zl.insertBefore(c, before || null);
    if (c) c.style.display = LASTLAB ? "none" : "";
    // during boot the row is still detached — getElementById misses, use the passed node
    // ONE count on the page, on the left (Summer 2026-09-07). Ours always shows —
    // it is the only one that tells the truth after a search. The theme's own centred
    // "372 products" is hidden for good, and the breadcrumb steps aside for a search
    // label so the two never sit on top of each other.
    const cnt = document.getElementById("wlcount") || before;
    if (cnt) cnt.style.display = "";
    if (c) c.style.display = LASTLAB ? "none" : "";
    document.querySelectorAll(".collection-toolbar__products-count")
      .forEach(e => { e.style.display = "none"; });
    return c;
  }
  function stripHome() {
    let home = document.getElementById("wlstriphome");
    // A theme re-render can leave an EARLIER row in place, so two #wlstriprow (and
    // two #wlcount) end up in the toolbar. The stale one keeps the old "372 products"
    // and it stacked under the live "… — 40 artworks", two totals arguing on one
    // screen (Summer 2026-09-07). Only the row that owns the saved strip survives.
    const dropOthers = keep => document.querySelectorAll("#wlstriprow")
      .forEach(r => { if (r !== keep) r.remove(); });
    if (home) { dropOthers(home.closest("#wlstriprow")); return home; }
    dropOthers(null);
    const main = document.getElementById("MainContent") || document.querySelector("main");
    const count = main && [...main.querySelectorAll("div,span,p")].find(n =>
      n.children.length === 0 && /^\d+\s+product/i.test(n.textContent.trim()));
    if (count) { if (!COUNT0) COUNT0 = count.textContent.trim(); count.style.display = "none"; }
    const row = document.createElement("div");
    row.id = "wlstriprow";
    // Desktop (>700) puts the whole row in the toolbar, as it always has.
    // Mobile: ONLY the count/search-result joins the toolbar beside the display
    // cards — Saved keeps its own line below. (Summer 2026-07-15: moving both is
    // what deformed the line.)
    const tb = (main || document).querySelector(".collection-toolbar");
    const wide = window.innerWidth > 700;
    row.style.cssText = (tb && wide) ? "flex:1 1 340px;padding:8px 1.25rem"
                                     : "padding:8px 0;margin:0 0 4px";
    const zl = document.createElement("span"); zl.id = "wlzl";
    const zr = document.createElement("span"); zr.id = "wlzr";
    const cnt = document.createElement("span");
    cnt.id = "wlcount";
    cnt.style.cssText = "font-size:12px;letter-spacing:.08em;text-transform:uppercase;color:#555";
    cnt.textContent = COUNT0 || "";
    home = document.createElement("span");
    home.id = "wlstriphome"; home.className = "wltbstrip"; home.style.position = "relative";
    zl.appendChild(cnt); zr.appendChild(home);
    const seatCentre = () => { const ctr = tb.querySelector(".collection-toolbar__center");
      if (ctr) { ctr.style.position = "static"; ctr.style.transform = "none"; ctr.style.alignSelf = "center"; }
      return ctr; };
    if (tb && wide) {                       // desktop: count + saved together, as before
      row.appendChild(zl); row.appendChild(zr);
      adoptCrumb(zl, cnt);
      tb.insertBefore(row, seatCentre() || tb.children[1] || null); return home;
    }
    if (tb) {                               // mobile: count in the toolbar, Saved below
      zl.style.cssText += ";flex:1 1 auto;min-width:0;padding:0 10px";
      // one owned flex row: [grid icons] left, [count + sourcing offer] right
      // (Summer 2026-09-02) — the theme's own toolbar cells wrapped the count
      // onto its own line, so the switch and the zone get a shared wrapper
      const sw = tb.querySelector("collection-layout-switch");
      if (sw) {
        const wrap = document.createElement("div");
        wrap.id = "wltbrow";
        wrap.style.cssText = "display:flex;align-items:center;justify-content:space-between;" +
          "gap:8px;flex:1 1 100%;min-width:0;padding:0 10px";
        tb.insertBefore(wrap, sw);
        wrap.appendChild(sw);
        wrap.appendChild(zl);
      } else tb.insertBefore(zl, seatCentre() || tb.children[1] || null);
      adoptCrumb(zl, cnt);
      row.appendChild(zr);                  // the row below now carries Saved only
    } else { row.appendChild(zl); row.appendChild(zr); adoptCrumb(zl, cnt); }
    const g = natGrid();
    if (g && g.container.parentElement) { g.container.parentElement.insertBefore(row, g.container); return home; }
    if (main) { main.insertBefore(row, main.firstChild); return home; }
    row.remove(); return null;
  }
  const SAVED_MAX = 30;
  let stripPage = 0;                        // 0 = newest window
  function savedWin() {                     // window size adapts to available width
    const row = document.getElementById("wlstriprow");
    const pdp = document.getElementById("wlpdpstrip");
    const host = row || (pdp && pdp.parentElement); if (!host) return 10;
    const zr = document.getElementById("wlzr");
    // Mobile: exactly SIX, always. Deriving it from width gave 6 on my 375 test but
    // 7-8 on a wider phone, which wrapped the strip onto two lines. (Summer 2026-07-15)
    if (window.innerWidth <= 700) return 6;
    const thumb = 50 + 9;                                         // img + gap
    let avail = host.clientWidth - 235;                           // label+paging+links+mail
    if (row && zr)                                                // strip lives in its own half-zone now
      avail = zr.clientWidth - 235;
    return Math.max(2, Math.min(10, Math.floor(avail / thumb)));
  }
  const MAILSVG = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#425934" stroke-width="2" style="display:block"><rect x="3" y="5" width="18" height="14" rx="1"/><path d="M3 7l9 6 9-6"/></svg>';
  function savedWindow() {
    const W = savedWin(), total = S.sel.length;
    stripPage = Math.max(0, Math.min(stripPage, Math.ceil(total / W) - 1));
    const end = Math.max(0, total - stripPage * W);
    const start = Math.max(0, end - W);
    return { list: S.sel.slice(start, end), more: start > 0, newer: stripPage > 0 };
  }
  function savedHtml() {
    const w = savedWindow();
    return `<span class="lbl">Saved (${S.sel.length})</span>` +
      (w.more ? `<button data-pg="1" style="border:1px solid #d8d3cb;background:#fff;cursor:pointer;padding:2px 7px">‹</button>` : "") +
      w.list.map(i => `<span data-i="${i}" style="position:relative;display:inline-block">
        <img src="${API}/thumbs/${i}.jpg${iv(byI(i))}" title="${(byI(i) ? cardLabel(byI(i)) : i).replace(/"/g, "")}">
        <button data-x="${i}">✕</button></span>`).join("") +
      (w.newer ? `<button data-pg="-1" style="border:1px solid #d8d3cb;background:#fff;cursor:pointer;padding:2px 7px">›</button>` : "") +
      `<button class="lnk" data-viewall style="background:none;border:none;color:#425934;text-decoration:underline;cursor:pointer;font:11px Helvetica;white-space:nowrap">` +
      (window.innerWidth <= 700 ? "View all" : "View all saved") + `</button>` +
      `<button data-mail title="Email me this list" style="border:none;background:none;cursor:pointer;padding:2px">${MAILSVG}</button>`;
  }
  function wireSaved(el, rerender) {
    el.querySelectorAll("[data-pg]").forEach(b => b.onclick = () => { stripPage += +b.dataset.pg; rerender(); });
    el.querySelectorAll("[data-i] img").forEach(n => n.onclick = () => {
      const c = byI(n.parentElement.dataset.i); if (c && c.url) location.href = c.url; });
    el.querySelectorAll("[data-x]").forEach(x => x.onclick = e => { e.stopPropagation();
      const i = x.dataset.x; const k = S.sel.indexOf(i); if (k >= 0) S.sel.splice(k, 1);
      try { localStorage.wl_selected = JSON.stringify(S.sel); } catch (e2) {}
      stripPage = Math.min(stripPage, Math.max(0, Math.ceil(S.sel.length / savedWin()) - 1));
      refreshPills(); rerender(); });
    const va = el.querySelector("[data-viewall]");
    if (va) va.onclick = () => {
      if (IS_PDP || IS_HOME) { try { localStorage.wl_restore = ""; } catch (e2) {}
        location.href = "/collections/all?wlsaved=1"; }
      else showSaved(); };
    const em = el.querySelector("[data-mail]");
    if (em) em.onclick = async () => {
      const email = await new Promise(res => {
        const ov = document.createElement("div");
        ov.style.cssText = "position:fixed;inset:0;z-index:2147483100;background:rgba(20,20,20,.55);display:flex;align-items:center;justify-content:center;padding:16px";
        ov.innerHTML = '<div style="background:#fff;padding:20px;max-width:380px;width:100%;font-family:' + getComputedStyle(document.body).fontFamily + '">' +
          '<div style="font-size:.9375rem;font-weight:600;margin:0 0 10px">Where should we send your saved artworks?</div>' +
          '<input type="email" placeholder="you@email.com" style="width:100%;box-sizing:border-box;font-size:14px;padding:10px;border:1px solid #d8d3cb" value="' + (localStorage.wl_email || "") + '">' +
          '<div style="margin-top:12px;display:flex;gap:12px;align-items:center">' +
          '<button class="ok" style="background:#425934;color:#fff;border:none;padding:10px 20px;font-size:12px;letter-spacing:.08em;text-transform:uppercase;cursor:pointer;font-family:inherit">Send</button>' +
          '<button class="no" style="background:none;border:none;color:#425934;text-decoration:underline;cursor:pointer;font-size:12px;font-family:inherit">cancel</button></div></div>';
        document.body.appendChild(ov);
        const inp = ov.querySelector("input"); setTimeout(() => inp.focus(), 50);
        const done = v => { ov.remove(); res(v); };
        ov.querySelector(".ok").onclick = () => { const v = inp.value.trim();
          if (!v || v.indexOf("@") < 1) { inp.focus(); return; }
          try { localStorage.wl_email = v; } catch (e) {} done(v); };
        ov.querySelector(".no").onclick = () => done(null);
        ov.onclick = e => { if (e.target === ov) done(null); };
        inp.onkeydown = e => { if (e.key === "Enter") ov.querySelector(".ok").click(); };
      });
      if (!email) return;
      S.email = email;
      const r = await api("/api/enquiry", { kind: "saved_list", email, ts: await tsGet(),
        items: S.sel.map(i => { const c = byI(i); return c ? { index: i, title: dispTitle(c.title, c.artist), url: c.url } : { index: i }; }) });
      em.replaceWith(Object.assign(document.createElement("span"),
        { style: "font:11px Helvetica;color:#6b6b6b", textContent: (r && r.message) || "Sent." })); };
  }
  function showSaved() {
    const cards = S.sel.map(byI).filter(Boolean);
    S.lastResults = cards; LASTLAB = "Your saved"; SRCQ = null; nativeRender(viewList(cards)); setCount(cards.length, LASTLAB); chipsUI();
    document.getElementById("wlecho").innerHTML = "";
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  function strip() { try {
    if (IS_PDP || IS_MURALS) return;
    const el = stripHome(); if (!el) return;
    // WL 2026-07-31 (Summer): the Saved strip only shows on the saved view itself
    // (?wlsaved=1, reached via the header heart). On ordinary collection/search
    // pages it is gone — the header heart count replaces it. Neater, esp. mobile.
    if (!new URL(location.href).searchParams.get("wlsaved")) { el.innerHTML = ""; return; }
    el.innerHTML = S.sel.length ? savedHtml()
      : `<span class="lbl" style="color:#999">Saved (0) — press “Save” on any artwork</span>`;
    if (S.sel.length) wireSaved(el, strip);
  } catch (err) { console.warn("wl strip:", err); } }
  function panel() { const el = document.getElementById("wlpanel"); if (el) el.innerHTML = ""; }

  // ================= fallback grid =================
  function grid(cards, label) {
    S.shown = cards;
    const g = document.getElementById("wlgrid");
    g.innerHTML = cards.map(c => `<div class="c" data-i="${c.index}">
      <button class="chk ${S.sel.includes(c.index) ? "on" : ""}" data-chk="${c.index}">${S.sel.includes(c.index) ? "✓" : ""}</button>
      <img loading="lazy" src="${API}/thumbs/${c.index}.jpg${iv(c)}">
      <div class="t" title="${String(c.title || "").replace(/"/g, "")}">${cardLabel(c)}</div><div class="p">from ${money(c.price_min)}</div></div>`).join("");
    g.querySelectorAll(".c").forEach(n => n.onclick = e => {
      if (e.target.dataset.chk) return;
      const c = byI(n.dataset.i); if (c && c.url) window.open(c.url, "_blank");
    });
    g.querySelectorAll("[data-chk]").forEach(b => b.onclick = () => {
      const i = b.dataset.chk, k = S.sel.indexOf(i);
      if (k < 0 && S.sel.length >= SAVED_MAX) return;
      if (k >= 0) S.sel.splice(k, 1); else { S.sel.push(i); S.active = i; stripPage = 0; wlPing("save", { ix: i }); }
      localStorage.wl_selected = JSON.stringify(S.sel);
      b.classList.toggle("on", k < 0); b.textContent = k < 0 ? "✓" : "";
      strip(); panel();
    });
    if (label) document.getElementById("wlecho").textContent = label;
  }

  // ================= native-grid rendering =================
  let NAT = null;
  const CARD_SEL = "product-card, li, .product-card, .product-item, article, .grid__item";
  function natGrid(){
    if (NAT) return NAT;
    const a = [...document.querySelectorAll("#MainContent a[href*='/products/'], main a[href*='/products/']")]
      .find(x => !x.closest("#wlb,#wlqv,#wlov,#wl-studio-root"));
    if (!a) return null;
    const card = a.closest(CARD_SEL) || a;
    const container = card.parentElement;
    NAT = { container, items: Array.from(container.children), tpl: card };
    return NAT;
  }
  function forceReveal(scope){
    (scope || document).querySelectorAll("product-card, [reveal-on-scroll]").forEach(el => {
      try { el.getAnimations({ subtree: true }).forEach(a => a.cancel()); } catch (e) {}
      el.removeAttribute("reveal-on-scroll"); el.style.opacity = "1"; el.style.transform = "none"; });
  }
  // ONE title line for every card (Summer 2026-09-07). Name and artist share it.
  // Two lines were tried first and rejected. A plain one-line ellipsis cut the
  // ARTIST off the end, which is the half Summer needs on her own editions — so
  // the box is a flex row: the NAME shortens when it must, the artist never does.
  function twoLine(t) {
    t.style.display = "flex"; t.style.alignItems = "baseline";
    t.style.gap = "6px"; t.style.whiteSpace = "nowrap";
    t.style.overflow = "hidden"; t.style.lineHeight = "1.25";
    t.style.minWidth = "0"; t.style.flex = "1 1 auto";
    t.style.webkitLineClamp = ""; t.style.webkitBoxOrient = "";
  }
  // phone = 400px is plenty for a half-width card at 2x; desktop cards get 800px
  const sizedImg = u => { try {
      if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(u)) return u;
      const x = new URL(u, location.href);
      if (!x.searchParams.get("width")) x.searchParams.set("width", innerWidth <= 699 ? "400" : "800");
      return x.toString(); } catch (e) { return u; } };
  // Summer 2026-09-13: the theme's srcset "sizes" says a phone card is FULL width,
  // but we show 2 (or 4) per row — so every card fetched the 800px/133 KB file
  // where 400px/44 KB is enough (6.2 MB a page → 2.1 MB). Tell the browser the
  // real card width; it picks the right candidate itself. Desktop untouched.
  function fixCardSizes(scope){
    if (IS_PDP || innerWidth > 699) return;
    const pl = document.querySelector("product-list");
    const layout = pl ? pl.getAttribute("collection-mobile-layout") : "medium";
    const per = pl && pl.classList.contains("wl-4up") ? 4 : (layout === "large" ? 1 : 2);
    const sz = per === 1 ? "100vw" : per === 4 ? "25vw" : "50vw";
    (scope || document).querySelectorAll("product-card img[srcset]").forEach(im => {
      if (im.getAttribute("sizes") !== sz) im.setAttribute("sizes", sz); });
  }
  function nativeRender(results){
    const g = natGrid();
    if (!g) { grid(results, ""); return; }
    g.items.forEach(el => { if (!el.dataset.wlClone) el.style.display = "none"; });
    g.container.querySelectorAll("[data-wl-clone]").forEach(el => el.remove());
    for (const c of results) {
      const el = g.tpl.cloneNode(true);
      el.dataset.wlClone = "1"; el.removeAttribute("data-wl"); el.style.display = "";
      el.removeAttribute("reveal-on-scroll"); el.style.transform = "none";
      try { el.getAnimations({ subtree: true }).forEach(a => a.cancel()); } catch (e2) {}
      el.querySelectorAll(".wlsel").forEach(x => x.remove());
      el.querySelectorAll("a").forEach(x => x.setAttribute("href", c.url || "#"));
      // Summer 2026-09-10: the clone carried the TEMPLATE artwork's decoded picture, so
      // every cell showed the same painting until its own image arrived ("the whole
      // page is one art"). A FRESH <img> replaces it: nothing is painted until this
      // artwork's own picture has loaded, and the cell stays invisible until then.
      el.style.opacity = "0"; el.style.transition = "opacity .18s";
      const imgs = el.querySelectorAll("img");
      // Summer 2026-09-13: c.image is the ORIGINAL file (577 KB each — a 40-card
      // search pulled ~23 MB). Shopify's CDN resizes on request: 400px on a phone
      // (2-up cards), 800px on desktop. Same picture, 4-10x lighter.
      const src = c.image ? sizedImg(c.image) : (API + "/thumbs/" + c.index + ".jpg" + iv(c));
      let shown = false;
      const reveal = () => { if (shown) return; shown = true; el.style.opacity = "1"; };
      imgs.forEach((im, k) => {
        if (k > 0) { im.remove(); return; }
        const fresh = document.createElement("img");
        for (const at of Array.from(im.attributes)) {
          if (["src", "srcset", "data-srcset", "sizes", "width", "height", "loading", "fetchpriority"].includes(at.name)) continue;
          fresh.setAttribute(at.name, at.value);
        }
        fresh.alt = c.title || ""; fresh.loading = "eager"; fresh.decoding = "async";
        fresh.addEventListener("load", reveal, { once: true });
        fresh.addEventListener("error", reveal, { once: true });
        fresh.src = src;
        im.replaceWith(fresh);
        if (fresh.complete && fresh.naturalWidth) reveal();
      });
      if (!imgs.length) reveal();
      setTimeout(reveal, 6000);            // never leave a cell invisible on a slow network
      const t = el.querySelector(".product-title, a.product-title, .product-item__title, .product-card__title, h3 a, h2 a, .card__heading a, a[href*='/products/'] span") ||
                el.querySelector("h3, h2");
      if (t) { t.innerHTML = cardLabelHTML(c); t.setAttribute("title", c.title);
        twoLine(t); }
      const pr = el.querySelector("price-list, .price, .product-item__price-list, .product-card__price, [class*='price']");
      if (pr) pr.textContent = "from " + money(c.price_min);
      g.container.appendChild(el);
    }
    fixCardSizes(g.container);
    if (!results.length) {                       // never leave a silent blank grid
      const m = document.createElement("div");
      m.dataset.wlClone = "1";
      m.style.cssText = "grid-column:1/-1;width:100%;padding:56px 16px;text-align:center;font:14px Helvetica;color:#555";
      m.innerHTML = 'No matches for that combination. <button class="lnk" style="font:inherit;text-decoration:underline;background:none;border:none;color:inherit;cursor:pointer">Clear the search and filters</button>';
      m.querySelector("button").addEventListener("click", clearAll);
      g.container.appendChild(m);
    }
    nativeInject();
  }
  function nativeRestore(){
    const g = natGrid(); if (!g) return;
    g.container.querySelectorAll("[data-wl-clone]").forEach(el => el.remove());
    g.items.forEach(el => el.style.display = "");
  }
  function portalGo(state) {                     // home page: hand the state to the catalogue
    try { localStorage.wl_last_search = JSON.stringify({ url: "/collections/all", y: 0, t: Date.now(), ...state });
      localStorage.wl_restore = "1"; } catch (e) {}
    location.href = "/collections/all";
  }
  async function search(fromHelp) {
    try {
      const q = document.getElementById("wlq").value.trim();
      if (IS_HOME) { if (q) portalGo({ q, chip: CHIP, hints: fromHelp ? S.help.hints : null }); return; }
      if (!q) { S.lastResults = null; applyChips(); return; }
      document.getElementById("wlecho").textContent = "";
      progOn(true);                      // the bar in the box IS the "we are looking" signal
      track(fromHelp ? "wl_help_choose" : "wl_search", { q });
      const r = await api("/api/search", fromHelp ? { q, hints: S.help.hints } : { q });
      if (!r || !Array.isArray(r.results)) throw new Error("bad response");
      S.lastResults = r.results;
      const list = viewList(r.results);
      nativeRender(list);
      saveLast();
      // closest (2026-09-02): the worker flags searches with no real evidence —
      // gibberish must not read as 40 confident "matches", and the visitor gets
      // the ask-Summer personal sourcing form (shared from wl_search.js)
      const closest = !fromHelp && !!r.closest;
      LASTLAB = fromHelp ? "Chosen for you"
        : (closest ? `Closest to “${q}” (no exact match)` : `Matches for “${q}”`);
      SRCQ = closest ? q : null;   // setCount appends the sourcing line beside the count
      setCount(list.length, LASTLAB);
      chipsUI();          // the sort dropdown just switched into search mode
      if (fromHelp) helpEcho(list.length);
      // the worker's daily cap answers with empty results + a polite note — show it
      else document.getElementById("wlecho").textContent = (!r.results.length && r.message) ? r.message : "";
    } catch (err) { console.warn("wl search:", err);
      document.getElementById("wlecho").innerHTML =
        `The search had a hiccup — <button class="lnk" onclick="document.getElementById('wlgo').click()">try again</button>`;
    } finally { progOn(false); }
  }
  // one switch for the in-box progress bar, so no path can leave it running
  function progOn(on) { const p = document.getElementById("wlprog");
    if (p) p.classList.toggle("on", !!on); }
  function clearAll(){
    S.lastResults = null; LASTLAB = null; document.getElementById("wlq").value = "";
    CHIP.type = CHIP.layout = CHIP.artist = CHIP.edition = CHIP.ratio = CHIP.sort = null; CHIP.colours = [];
    chipsUI(); nativeRestore(); document.getElementById("wlecho").innerHTML = ""; saveLast(); setCount(null);
  }

  // ================= HELP ME CHOOSE (R2) =================
  const HOPT = {
    room: ["living room", "bedroom", "office", "dining room", "entryway", "hallway",
           "kitchen", "bathroom", "feature wall", "staircase"],   // = custom.room choices (2026-07-20)
    feel: ["calm", "bold", "warm", "moody", "fresh"],
    wall: ["tall", "wide", "square"],
    scale: ["statement", "balanced", "accent"],
    style: ["abstract", "famous masters", "painterly", "black & white", "minimal"],
  };
  const HDOTS = { Black:"#1b1b1b", White:"#f4f1ec", Grey:"#9a9a9a", Brown:"#7a5236", Gold:"#c8a24a",
    Yellow:"#f2dd66", Orange:"#d97b2e", Red:"#b23230", Pink:"#d98ba0", Purple:"#7d5a9e",
    Blue:"#3b5f8f", "Light Blue":"#a9c7e4", Aqua:"#5fa8a0", Green:"#4b7a4f", Olive:"#7c7a3f" };
  const helpOv = document.getElementById("wlhelpov"), helpEl = document.getElementById("wlhelp");
  function helpClose(){ helpOv.style.display = "none"; }
  helpOv.onclick = e => { if (e.target === helpOv) helpClose(); };
  function helpOpen(){
    const a = S.help.a || (S.help.a = { colours: [] });
    const opts = (key, list) => `<div class="opts">` + list.map(o =>
      `<button class="op${a[key] === o ? " on" : ""}" data-k="${key}" data-v="${o}">${o}</button>`).join("") + `</div>`;
    helpEl.innerHTML = `
      <h3>Help me choose</h3>
      <p style="font:11px Helvetica;color:#6b6b6b;margin:2px 0 0">Answer what you like, skip the rest — we narrow the collection to your best matches.</p>
      <div class="q">Where will it hang?</div>${opts("room", HOPT.room)}
      <div class="q">How should the room feel?</div>${opts("feel", HOPT.feel)}
      <div class="q">Colours to lean into <span style="letter-spacing:0;text-transform:none">(up to three — or let the art decide)</span></div>
      <div class="opts">${Object.entries(HDOTS).map(([n, h]) =>
        `<button class="hdot${a.colours.includes(n) ? " on" : ""}" data-co="${n}" title="${n}" style="background:${h}"></button>`).join("")}</div>
      <div class="q">Your wall</div>${opts("wall", HOPT.wall)}
      <div class="q">How large should it live?</div>${opts("scale", HOPT.scale)}
      <div class="q">A style lean?</div>${opts("style", HOPT.style)}
      <div class="foot">
        <button class="btn" id="wlhgo" style="background:var(--wlbtn,#425934);color:var(--wlbtnfg,#fff);border:none;padding:11px 20px;font:10px Helvetica;letter-spacing:.14em;text-transform:uppercase;cursor:pointer">Show my matches</button>
        <button class="lnk" id="wlhx" style="background:none;border:none;color:#425934;text-decoration:underline;cursor:pointer;font:11px Helvetica">cancel</button>
      </div>`;
    helpEl.querySelectorAll(".op").forEach(b => b.onclick = () => {
      const k = b.dataset.k; a[k] = a[k] === b.dataset.v ? null : b.dataset.v; helpOpen(); });
    helpEl.querySelectorAll(".hdot").forEach(b => b.onclick = () => {
      const n = b.dataset.co, k = a.colours.indexOf(n);
      if (k >= 0) a.colours.splice(k, 1); else if (a.colours.length < 3) a.colours.push(n); helpOpen(); });
    helpEl.querySelector("#wlhx").onclick = helpClose;
    helpEl.querySelector("#wlhgo").onclick = helpRun;
    helpOv.style.display = "flex";
  }
  function helpQuery(extra){
    const a = S.help.a || { colours: [] };
    const bits = [];
    if (a.feel) bits.push(a.feel);
    if (a.style) bits.push(a.style === "famous masters" ? "famous master painting" : a.style);
    bits.push("artwork");
    if (a.colours.length) bits.push("in " + a.colours.map(c => c.toLowerCase()).join(", "));
    if (a.room) bits.push("for the " + a.room);
    if (a.scale) bits.push({ statement: "a large statement piece", balanced: "comfortably scaled",
                             accent: "a quieter accent piece" }[a.scale]);
    if (extra) bits.push(extra);
    return bits.join(" ");
  }
  function helpRun(extra){
    const a = S.help.a || { colours: [] };
    S.help.hints = {
      colours: a.colours.map(c => c.toLowerCase()),
      orientation: { tall: "portrait", wide: "landscape", square: "square" }[a.wall] || null,
      room: a.room || null };
    helpClose();
    document.getElementById("wlq").value = helpQuery(typeof extra === "string" ? extra : "");
    search(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  function helpEcho(n){
    const el = document.getElementById("wlecho");
    el.innerHTML = `Refine: ` +
      ["calmer", "bolder", "warmer", "cooler", "bigger scale", "something different"]
        .map(w => `<button class="lnk" data-hr="${w}">${w}</button>`).join(" · ") +
      ` &nbsp;·&nbsp; <button class="lnk" id="wlhredo">change my answers</button>` +
      ` · <button class="lnk" id="wlhsummer">Email Summer</button>` +
      ``;
    el.querySelectorAll("[data-hr]").forEach(b => b.onclick = () => helpRun(b.dataset.hr));
    el.querySelector("#wlhredo").onclick = helpOpen;
    el.querySelector("#wlhsummer").onclick = () => {
      el.innerHTML = '<span style="font:12.5px Helvetica">Email Summer — ' +
        '<input id="wlhse" placeholder="your email" style="font:12px Helvetica;padding:5px;border:1px solid #d8d3cb;width:170px" value="' + (S.email || "") + '"> ' +
        '<input id="wlhsm" placeholder="what are you looking for?" style="font:12px Helvetica;padding:5px;border:1px solid #d8d3cb;width:min(320px,60vw)"> ' +
        '<button class="btn" id="wlhssend">Send</button></span>';
      el.querySelector("#wlhssend").onclick = async () => {
        const email = el.querySelector("#wlhse").value.trim();
        const msg = el.querySelector("#wlhsm").value.trim();
        if (!email) { el.querySelector("#wlhse").focus(); return; }
        S.email = email; localStorage.wl_email = email;
        await api("/api/enquiry", { kind: "help_fallback", email, message: msg, answers: S.help.a, q: helpQuery(), ts: await tsGet() });
        el.textContent = "Sent — Summer will come back to you personally with a short list."; }; };
  }
  document.getElementById("wlhmc").onclick = helpOpen;

  // ================= filters =================
  const CHIP = { type: null, colours: [], edition: null, layout: null, artist: null, ratio: null, sort: null };
  const DOTS = HDOTS;
  const RATIOS = [[1,"1:1 square"],[1.12,"9:8"],[1.25,"5:4"],[1.33,"4:3"],[1.5,"3:2"],[1.75,"7:4"],[2,"2:1"],[2.5,"5:2"],[3,"3:1"]];
  function ratioOf(c){
    const s = (c.sizes || []).find(x => x.includes("x") && !x.includes("pc")); if (!s) return null;
    const [a, b] = s.split("x").map(n => parseInt(n)); if (!a || !b) return null;
    const r = Math.max(a, b) / Math.min(a, b);
    let best = RATIOS[0]; for (const rb of RATIOS) if (Math.abs(rb[0] - r) < Math.abs(best[0] - r)) best = rb;
    return best[1];
  }
  const dd = (id, label, opts, cur) =>
    `<select id="${id}" style="font:9.5px Helvetica;letter-spacing:.08em;text-transform:uppercase;border:1px solid #e6e2dc;padding:5px;background:#fff;color:#555;max-width:170px">
      <option value="">${label}</option>${opts.map(o => `<option ${cur===o?'selected':''}>${o}</option>`).join("")}</select>`;
  // Sort belongs IN the search bar, not as the theme's separate control beside it
  // (Summer 2026-07-15). One dropdown, two engines behind it:
  //   · live search / filters / saved → sort OUR result list right here, in the
  //     same pipeline as the chips (results reorder in place, nothing reloads);
  //   · plain catalogue → navigate with ?sort_by= so the theme sorts server-side.
  //     Never drive its popover buttons: the theme applies sort by REPLACING the
  //     whole collection section (facets AJAX), which wipes a live search and
  //     orphans natGrid()'s cached nodes — the next search then renders nowhere.
  const SORT_POP = () => document.querySelector("#sort-by-popover");
  function sortBtns() { const p = SORT_POP();
    return p ? [...p.querySelectorAll("button[value]")] : []; }
  // comparators for the WL-rendered list. Orders the library carries no data for
  // (best selling, date added) stay theme-only and grey out while a search is
  // live — never fake an order we can't compute.
  const SORTERS = {
    "price-ascending":  (a, b) => (+a.price_min || 0) - (+b.price_min || 0),
    "price-descending": (a, b) => (+b.price_max || 0) - (+a.price_max || 0),
    "title-ascending":  (a, b) => cardLabel(a).localeCompare(cardLabel(b)),
    "title-descending": (a, b) => cardLabel(b).localeCompare(cardLabel(a)),
  };
  const NATURAL = v => v === "manual" || /relevan/.test(v);   // = the list's own order
                                       // (theme offers "most-relevant"; /search uses "relevance")
  const urlSort = () => new URLSearchParams(location.search).get("sort_by") || "";
  const wlMode = () => !!(S.lastResults || CHIP.type || CHIP.colours.length ||
    CHIP.edition || CHIP.layout || CHIP.artist || CHIP.ratio);
  // explicit pick wins; else honour the page's own ?sort_by when we can; else the
  // list's natural order (relevance for a search, Summer's order for saved)
  function sortCards(list) {
    // colours picked + no EXPLICIT user sort -> most colour-dominant first (the
    // grid leads with true matches); the URL's default sort must not undo it
    if (CHIP.colours.length && !CHIP.sort && window.WLColour)
      return list.map(c => [c.pal ? WLColour.wantScore(c.pal, CHIP.colours) : 0, c])
        .sort((a, b) => b[0] - a[0]).map(([, c]) => c);
    const f = SORTERS[CHIP.sort || urlSort()];
    return f ? [...list].sort(f) : list;
  }
  const viewList = base => sortCards(chipFilter(base));
  function sortDd() {
    const btns = sortBtns();
    if (!btns.length) return "";
    const wl = wlMode();
    const natural = (btns.find(b => NATURAL(b.value)) || btns[0]).value;
    const cur = wl
      ? (SORTERS[CHIP.sort || urlSort()] ? (CHIP.sort || urlSort()) : natural)
      : urlSort() || (btns.find(b => b.getAttribute("aria-selected") === "true") || btns[0]).value;
    // Summer 2026-08-13: first option is "Sort by" — it IS the default order
    // (same value as the natural sort, so it and "Featured" share one result).
    // Closed control therefore reads "SORT" until the shopper picks a sort.
    return `<select id="wlsort" style="font:9.5px Helvetica;letter-spacing:.08em;text-transform:uppercase;border:1px solid #e6e2dc;padding:5px;background:#fff;color:#555">` +
      `<option value="${natural}" ${cur === natural ? "selected" : ""}>Sort</option>` +
      btns.map(b => {
        const v = b.value;
        const label = (b.closest("label")?.textContent || b.textContent || v).replace(/\s+/g, " ").trim();
        const off = wl && !NATURAL(v) && !SORTERS[v];
        // the natural option (Featured / Most relevant) stays listed but never
        // carries selected — "Sort by" above already owns that state
        return `<option value="${v}" ${v === cur && v !== natural ? "selected" : ""}${off ? " disabled" : ""}>${label}</option>`;
      }).join("") + `</select>`;
  }
  function wireSort(el) {
    const s = el.querySelector("#wlsort"); if (!s) return;
    s.onchange = () => {
      if (wlMode()) { CHIP.sort = s.value; applyChips(); return; }
      // strip our own handoff params so the reload can't replay an old bar search
      const u = new URL(location.href);
      u.searchParams.set("sort_by", s.value);
      u.searchParams.delete("page");
      ["wlq", "wlhelp", "wlcam", "wlsaved"].forEach(k => u.searchParams.delete(k));
      location.href = u.toString();
    };
  }

  // A <select> sizes itself to its WIDEST option, so "All artists (48)" was as wide
  // as the longest artist name — three wrapped lines on a phone. Size each one to
  // the option actually showing. (Summer 2026-07-15)
  //
  // Measure by CLONING, never by guessing (Summer 2026-09-07). The old version drew
  // the label on a canvas in the font it THOUGHT was applied and added a fudge for
  // padding + arrow. It read Helvetica off our inline style while the theme actually
  // renders these in Montserrat, which is wider — so every label came out short and
  // the last two or three letters were cut off ("ART TY", "EDITIC", "SHA").
  // A clone holding only the showing option, sized natively, is exact: it uses the
  // real font, the real letter-spacing, the real padding and the real arrow.
  function fitSel(s) {
    const opt = s.options[s.selectedIndex];
    if (!opt || !s.parentNode) return;
    const c = s.cloneNode(false);
    c.removeAttribute("id");                               // never two of one id
    c.appendChild(opt.cloneNode(true));
    c.style.cssText += ";width:auto;max-width:none;position:absolute;left:-9999px;top:0;visibility:hidden";
    s.parentNode.appendChild(c);                           // same CSS context as the real one
    const w = c.getBoundingClientRect().width;
    c.remove();
    // A webfont that has not arrived yet draws its text with NO width at all, so the
    // clone comes back as bare arrow, about 16px. Trusting that once collapsed every
    // dropdown to an arrow with no label on it (2026-09-07). Anything under 40px is
    // that failure, never a real label — leave the select alone and let a retry fix it.
    if (w >= 40) s.style.width = Math.ceil(w) + "px";
  }
  function fitAllSels(el) {
    const all = () => el.querySelectorAll(".wlchips-dd select").forEach(x => fitSel(x));
    all();
    el.querySelectorAll(".wlchips-dd select")
      .forEach(x => x.addEventListener("change", () => fitSel(x)));
    // measure again once the font is really painted — whichever of these lands first
    requestAnimationFrame(all);
    setTimeout(all, 300);
    setTimeout(all, 1500);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(all).catch(() => {});
  }

  function chipsUI(){
    const el = document.getElementById("wlchips");
    const artists = [...new Set(S.cards.map(c => c.artist).filter(Boolean))].sort();
    const types = [...new Set(S.cards.flatMap(c => c.styles || []))].sort()
      .map(t => t === "Photography" ? "Photo" : t);
    const ratios = [...new Set(S.cards.map(ratioOf).filter(Boolean))]
      .sort((a, b) => RATIOS.findIndex(r => r[1] === a) - RATIOS.findIndex(r => r[1] === b));
    el.innerHTML =
      `<div class="wlchips-dd">` +
      dd("wltype", "Type", [...new Set(types)], CHIP.type) +
      dd("wlartist", "Artist", artists, CHIP.artist) +
      `<select id="wledition" style="font:9.5px Helvetica;letter-spacing:.08em;text-transform:uppercase;border:1px solid #e6e2dc;padding:5px;background:#fff;color:#555">
        <option value="">Edition</option>
        <option value="le" ${CHIP.edition==='le'?'selected':''}>Limited Edition</option>
        <option value="oe" ${CHIP.edition==='oe'?'selected':''}>Open Edition</option></select>` +
      dd("wlshape", "Shape", ["portrait","landscape","square"], CHIP.layout) +
      dd("wlratio", "Ratio", ratios, CHIP.ratio) +
      sortDd() +
      `</div><div class="wlchips-co">` +
      `<span id="wlchip-lab" title="Colours the artwork contains — pick up to three">colour</span>` +
      `<span class="wldots">` +
      Object.entries(DOTS).map(([n,h]) =>
        `<button class="dot ${CHIP.colours.includes(n)?'on':''}" data-co="${n}" title="${n} — artworks containing ${n.toLowerCase()}" style="background:${h}"></button>`).join("") +
      `</span>` +
      `<a class="alla" id="wlalla" href="/collections/extra-large-canvas-wall-art" title="Clear the search and show every artwork">All</a>` +
      `</div>`;
    const wire = (id, key) => { const s = el.querySelector("#" + id);
      if (s) s.onchange = () => { CHIP[key] = s.value || null; applyChips(); }; };
    wire("wltype", "type"); wire("wlartist", "artist"); wire("wledition", "edition");
    wire("wlshape", "layout"); wire("wlratio", "ratio");
    wireSort(el);
    fitAllSels(el);
    el.querySelectorAll("[data-co]").forEach(b => b.onclick = () => { const n = b.dataset.co; const k = CHIP.colours.indexOf(n);
      if (k >= 0) CHIP.colours.splice(k, 1); else if (CHIP.colours.length < 3) CHIP.colours.push(n); applyChips(); });
    const alla = el.querySelector("#wlalla");
    // "All artworks" = the full catalogue. On the main catalogue it just clears the
    // search/filters; on any OTHER collection it navigates to the full catalogue
    // (so it never shows a sub-collection's subset while saying "All artworks").
    if (alla) alla.onclick = e => {
      if (IS_HOME) return;
      if (/\/collections\/extra-large-canvas-wall-art/.test(location.pathname)) {
        e.preventDefault(); clearAll(); window.scrollTo({ top: 0, behavior: "smooth" });
      }
    };
  }
  // colour dots (2026-08-20): Summer's CURATED colours decide membership —
  // exact bucket match, no adjacency, no substring ("Blue" never pulls
  // "Light Blue"). Measured palette (WLColour.has) only for untagged cards.
  const coEq = (a, b) => String(a).toLowerCase().replace(/-/g, " ") ===
                         String(b).toLowerCase().replace(/-/g, " ");
  function hasColour(c, n) {
    if ((c.colours || []).length) return c.colours.some(x => coEq(x, n));
    return !!(window.WLColour && c.pal) && WLColour.has(c.pal, n);
  }
  function chipFilter(list){
    let out = list.filter(c =>
      (!CHIP.type || (c.styles||[]).some(x => (x === "Photography" ? "Photo" : x) === CHIP.type)) &&
      (!CHIP.artist || c.artist === CHIP.artist) &&
      CHIP.colours.every(n => hasColour(c, n)) &&
      (!CHIP.layout || c.orientation === ({portrait:'vertical',landscape:'horizontal',square:'square'})[CHIP.layout]) &&
      (!CHIP.ratio || ratioOf(c) === CHIP.ratio) &&
      (!CHIP.edition || (CHIP.edition === "le") === !!c.is_le));
    return out;
  }
  function applyChips(){
    chipsUI();
    if (IS_HOME) { if (CHIP.type || CHIP.colours.length || CHIP.edition || CHIP.layout || CHIP.artist || CHIP.ratio)
      portalGo({ q: document.getElementById("wlq").value.trim(), chip: CHIP }); return; }
    const base = S.lastResults || S.cards;
    if (!CHIP.type && !CHIP.colours.length && !CHIP.edition && !CHIP.layout && !CHIP.artist && !CHIP.ratio && !S.lastResults) {
      nativeRestore(); document.getElementById("wlecho").innerHTML = ""; saveLast(); setCount(null); return; }
    const list = viewList(base);
    nativeRender(list);
    saveLast();
    setCount(list.length, S.lastResults ? LASTLAB : null);
    document.getElementById("wlecho").innerHTML = "";
  }

  // ================= image search =================
  function camOpen() {
    const inp = document.createElement("input"); inp.type = "file"; inp.accept = "image/*";
    inp.onchange = () => { const f = inp.files[0]; if (!f) return;
      if (f.size > 5*1024*1024) { document.getElementById("wlecho").textContent = "Pictures up to 5 MB, please."; return; }
      const rd = new FileReader();
      rd.onload = async () => {
        document.getElementById("wlecho").textContent = "Reading your picture — searching the collection…";
        const r = await api("/api/image-search", { image: rd.result });
        if (!r.ok) { document.getElementById("wlecho").textContent = r.message || "Could not read that picture."; return; }
        if (IS_HOME) { portalGo({ q: "", chip: CHIP, results: (r.results || []).map(c => c.index).slice(0, 60) }); return; }
        S.lastResults = r.results; LASTLAB = "Matches for your picture"; SRCQ = null; const li = viewList(r.results); nativeRender(li); saveLast();
        setCount(li.length, LASTLAB); chipsUI();
        document.getElementById("wlecho").innerHTML = (r.kind === "exact"
          ? "We carry this exact artwork — it leads the results."
          : (r.message || "No exact match — here is what comes close.") +
            (window.WLAsk ? ' <button type="button" id="wlcamsrc" style="font:inherit;background:none;border:none;padding:0;color:inherit;text-decoration:underline;text-underline-offset:3px;cursor:pointer">Can’t find it? We’ll find it for you, free</button>' : ""));
        const cs = document.getElementById("wlcamsrc");   // free art finding (Summer 2026-09-17)
        if (cs) cs.onclick = () => window.WLAsk.open("");
      };
      rd.readAsDataURL(f); };
    inp.click(); }
  document.getElementById("wlcam").onclick = camOpen;
  document.getElementById("wlgo").onclick = () => search(false);
  document.getElementById("wlsrcbtn").onclick = () => window.WLAsk &&
    window.WLAsk.open(document.getElementById("wlq").value.trim());
  document.getElementById("wlq").addEventListener("keydown", e => { if (e.key === "Enter") search(false); });

  // ================= page reshaping =================
  // Summer 2026-07-13: mobile shows TWO artworks per row. The theme's collection
  // setting is "large" = 1-up on mobile; "medium" = 2-up. collection-mobile-layout
  // only drives the mobile render, so it's safe to set at any viewport width.
  // (To move this back to the theme setting later, delete this + its two callers.)
  // 2-up is only the DEFAULT — once the shopper picks a layout, stop overriding it
  // or their choice snaps back on the next reshape. (Summer 2026-07-15)
  let mobLayoutUser = false;
  function twoUpMobile(){
    if (IS_PDP || mobLayoutUser) return;
    document.querySelectorAll('product-list[collection-mobile-layout="large"]')
      .forEach(pl => pl.setAttribute("collection-mobile-layout", "medium"));
    fixCardSizes();
    // any later change (shopper picks 1 / 2 / 4 per row, theme re-renders the
    // grid on paging or filtering) re-sizes the cards it touched
    const pl = document.querySelector("product-list");
    if (pl && !pl.dataset.wlSizes) { pl.dataset.wlSizes = "1";
      new MutationObserver(() => fixCardSizes()).observe(pl,
        { attributes: true, attributeFilter: ["collection-mobile-layout", "class"], childList: true, subtree: true }); }
  }
  // Most-compact icon: 15 dots (5 across × 3 rows) — reads as "many small cards"
  // far better than the theme's bunch of lines. (Summer 2026-07-15)
  const DOTS15 = '<svg role="presentation" width="18" viewBox="0 0 18 18" fill="none">' +
    [3, 9, 15].map(y => [1, 5, 9, 13, 17].map(x =>
      `<circle cx="${x}" cy="${y}" r="1.35" fill="currentColor"/>`).join("")).join("") + "</svg>";
  // the theme's own most-compact button wears the same icon, so the two switchers agree
  function dotIcon() {
    document.querySelectorAll('collection-layout-switch button[value="compact"]').forEach(b => {
      if (b.dataset.wlDot) return; b.dataset.wlDot = "1"; b.innerHTML = DOTS15; });
  }

  // The theme's mobile switch only offers 1-up and 2-up. Summer wants 1 / 2 / 4,
  // so add the third ourselves: it reuses the theme's 2-up mode plus a .wl-4up
  // class that the CSS turns into four columns.
  function mobileLayoutUI(){
    if (IS_PDP) return;
    const sw = [...document.querySelectorAll("collection-layout-switch")]
      .find(s => s.getAttribute("device") === "mobile");
    if (!sw || sw.dataset.wl4) return;
    sw.dataset.wl4 = "1";
    const list = () => document.querySelector("product-list");
    const b4 = document.createElement("button");
    b4.type = "button"; b4.value = "wl4";
    b4.className = "collection-toolbar__button";
    b4.setAttribute("aria-label", "Switch to four products per row");
    b4.innerHTML = DOTS15;
    // theme's own buttons (1-up / 2-up): drop our mode and hand back over
    sw.querySelectorAll("button").forEach(b => b.addEventListener("click", () => {
      mobLayoutUser = true;
      const pl = list(); if (pl) pl.classList.remove("wl-4up");
      b4.classList.remove("is-active");
    }));
    b4.addEventListener("click", e => {
      e.stopImmediatePropagation();               // the theme has no "wl4" mode
      mobLayoutUser = true;
      const pl = list(); if (!pl) return;
      pl.setAttribute("collection-mobile-layout", "medium");
      pl.classList.add("wl-4up");
      sw.querySelectorAll("button").forEach(b => b.classList.remove("is-active"));
      b4.classList.add("is-active");
    }, true);
    sw.appendChild(b4);
  }
  function reshapePage(){
    if (IS_PDP) return;
    const banner = document.querySelector("[id*='collection-banner'],[class*='collection-banner'],[class*='collection__banner']");
    const main = document.getElementById("MainContent") || document.querySelector("main");
    // WL 2026-07-29 (Summer): murals collection keeps its banner at the TOP, under the
    // search bar. Everywhere else the SEO banner moves to the bottom — but ABOVE the
    // footer group (it used to appendChild AFTER the footer, which looked orphaned).
    if (banner && main && !banner.dataset.wlMoved) {
      banner.dataset.wlMoved = "1";
      if (/\/collections\/pre-designed-wall-murals/.test(location.pathname)) {
        // 2026-09-23: templates/collection(.context.au).json now SERVE the banner in its
        // bottom slot (moving it after load was the collection pages' biggest layout jump
        // in Google's phone test). Murals is the one page that keeps it at the top.
        const sb = main.querySelector("[id$='__wl-studio-bar']");
        if (sb && sb.nextElementSibling !== banner) sb.after(banner);
      } else {
        // Summer 2026-09-13: the collection text sits ABOVE "Explore more wall art" (wl-collection-links),
        // not under it — the artist's words first, the link block after. Footer stays the fallback.
        const fg = main.querySelector("[id*='recently-viewed'],[id*='wl-collection-links'],[id*='text-with-icons'],[id$='__footer']");
        if (fg) main.insertBefore(banner, fg); else main.appendChild(banner);
      }
    }
    document.querySelectorAll("#MainContent aside, form.facets, [class*='collection__filters'], [id*='Facet'], [class*='facets']")
      .forEach(el => { if (!el.closest("#wlb")) el.style.display = "none"; });
    const coll = document.querySelector(".collection");
    if (coll && getComputedStyle(coll).display === "grid") coll.style.gridTemplateColumns = "1fr";
    const cm = document.querySelector(".collection__main");
    if (cm) cm.style.gridColumn = "1 / -1";
    twoUpMobile(); mobileLayoutUI(); dotIcon();
    const g = natGrid(); if (g) forceReveal(g.container);
  }

  // ================= select pills =================
  const H2I = {};
  function handleOf(a){ const m = (a.getAttribute("href")||"").match(/\/products\/([a-z0-9-]+)/); return m ? m[1] : null; }
  function nativeInject(){ try {
    if (!S.cards.length || IS_PDP) return;
    if (!Object.keys(H2I).length) for (const c of S.cards) if (c.url) { const m = c.url.match(/\/products\/([a-z0-9-]+)/); if (m) H2I[m[1]] = c.index; }
    const g0 = natGrid(); if (!g0) return;
    g0.container.querySelectorAll("a[href*='/products/']").forEach(a => {
      if (a.closest("#wlqv,#wlb,#wlov,[id*='ecently'],[class*='ecently'],[class*='recommend'],[id*='recommend'],header,nav,footer")) return;
      const h = handleOf(a); const i = h && H2I[h];
      if (!i) return;   // not an artwork (Service / Gift Card) — leave it alone
      const card = a.closest(CARD_SEL) || a;
      if (card.dataset.wl) return; card.dataset.wl = i;
      const b = document.createElement("button");
      b.className = "wlsel" + (S.sel.includes(i) ? " on" : "");
      b.innerHTML = S.sel.includes(i) ? "✓ Saved" : "Save";
      b.onclick = e => { e.preventDefault(); e.stopPropagation();
        const k = S.sel.indexOf(i);
        if (k < 0 && S.sel.length >= SAVED_MAX) {
          document.getElementById("wlecho").textContent = "Saved is full (30) — remove one to add more.";
          window.scrollTo({ top: 0, behavior: "smooth" }); return; }
        if (k >= 0) S.sel.splice(k, 1); else { S.sel.push(i); S.active = i; stripPage = 0; wlPing("save", { ix: i }); }
        localStorage.wl_selected = JSON.stringify(S.sel);
        b.classList.toggle("on", k < 0); b.innerHTML = k < 0 ? "✓ Saved" : "Save";
        strip(); };
      if (card.querySelector(".wlsel")) return;
      const t = card.querySelector(".product-title, [class*='title'], h3, h2");
      // native theme cards print the FULL SEO title while the search grid prints
      // the short name — Summer 2026-07-15: one rule everywhere. Show the artwork
      // NAME only, one line, ellipsis when long. Rewrite only when the target is
      // a plain link/text whose content really is this product's title, so nested
      // price/badge markup can never be destroyed.
      if (t && !t.dataset.wlShort) {
        const c0 = byI(i), a2 = t.querySelector("a");
        const tgt = a2 || (t.children.length === 0 ? t : null);
        if (c0 && tgt && tgt.children.length === 0 &&
            tgt.textContent.trim().toLowerCase() === String(c0.title || "").trim().toLowerCase()) {
          tgt.innerHTML = cardLabelHTML(c0);
          tgt.setAttribute("title", c0.title);
          t.dataset.wlShort = "1";
        }
        // themes render the title as an inline <a> — inline boxes ignore overflow,
        // so the pill gets pushed off the card instead of the name ellipsising
        twoLine(t);
        // The theme's card stack is a grid with justify-items:center, so an
        // unconstrained nowrap title sizes to max-content and runs off the card
        // (223px of page scroll). The old Save row used to cap it; it doesn't
        // exist any more, so cap the title and its parent directly.
        t.style.maxWidth = "100%"; t.style.boxSizing = "border-box";
        if (t.parentElement) { const ps = t.parentElement.style;
          ps.width = "100%"; ps.maxWidth = "100%"; ps.minWidth = "0"; ps.boxSizing = "border-box"; }
      }
      // Summer 2026-07-15: Save rides ON the image, bottom-right. It used to sit
      // beside the title inside .product-card__info — which the COMPACT layout
      // hides, so the third view had no Save at all (pill present, zero height).
      // On the image it works in every layout, and costs the title no room.
      const fig = card.querySelector(".product-card__figure") ||
                  card.querySelector("[class*='figure'],[class*='media']");
      if (fig) {
        if (getComputedStyle(fig).position === "static") fig.style.position = "relative";
        b.classList.add("wlsel--img");
        fig.appendChild(b);
      } else if (t && t.parentElement) {
        t.parentElement.appendChild(b);
      } else { card.appendChild(b); }
    });
  } catch (err) { console.warn("wl inject:", err); } }

  // ================= boot =================
  // The customiser now ships as its own <script defer> in the page HTML, placed
  // BEFORE this file in sections/wl-studio-bar.liquid, so defer order guarantees
  // window.WLC is already defined by the time this runs. It used to be appended
  // from inside the library .then() below, which meant the browser could not
  // even begin that 48 KB download until a 48 KB cross-origin fetch had come
  // back: three sequential round trips, two origins, before the page was right.
  // Old cached HTML has no such tag, so we still append it in that case.
  let wlcP = null;
  const wlcReady = () => wlcP || (wlcP = new Promise(res => {
    if (window.WLC) return res(true);
    if (!document.querySelector('script[src*="wl-customiser"],script[src*="/app/customiser.js"]')) {
      const cj = document.createElement("script");
      cj.src = ASSET.customiser || (API + "/app/customiser.js");
      cj.defer = true;
      cj.onerror = () => res(false);
      document.head.appendChild(cj);
    }
    let n = 0; const iv = setInterval(() => {
      if (window.WLC) { clearInterval(iv); res(true); }
      else if (++n > 200) { clearInterval(iv); res(false); }   // 20s backstop
    }, 100);
  }));
  // Print-Your-Own mounts as soon as the customiser is parsed. It reads NOTHING
  // from the library: cfg.cards feeds only the Complete-the-Set band, which
  // WLC.setCards() fills in below when the cards arrive. Making the buy box wait
  // on that fetch is what put the raw layout in front of Summer.
  if (IS_OWN) wlcReady().then(ok => { if (ok) mountPdp(); });
  // 2026-09-24 SPEED: artwork pages build as soon as the customiser is parsed, from
  // the card the page carries (index checked identical to the library on all 418
  // artwork pages, 24 Sep). Complete-the-Set fills in when the library lands.
  const PAGE_CARD = (!IS_OWN && IS_PDP && window.__wlCard && window.__wlCard.index) ? window.__wlCard : null;
  if (PAGE_CARD) wlcReady().then(ok => { if (ok) mountPdp(PAGE_CARD); });

  (async () => {
    // Chat icon belongs in the header on EVERY page — this must sit in boot, not in
    // mountPdp(), or it only ever runs on product pages. The app mounts late, so retry.
    if (!chatInHeader()) { let n = 0; const iv = setInterval(() => {
      if (chatInHeader() || ++n > 40) clearInterval(iv); }, 250); }
    let l = null;
    // A payload without a cards ARRAY is not a library, it is an outage. The
    // worker answers {error:"library not loaded"} with HTTP 200, so r.ok passed,
    // S.cards became undefined and chipsUI() threw on S.cards.map — and the bad
    // object had already been written to localStorage, keeping the visitor
    // broken for 5 minutes after the worker recovered. (audit 2026-08-24)
    const libOK = d => !!(d && Array.isArray(d.cards));
    try { const c = JSON.parse(localStorage.wl_lib || "null");
      if (c && Date.now() - c.t < 300e3 && libOK(c.d)) l = c.d; } catch (e) {}   // 5 min — titles/prices refresh fast
    if (!l) { l = await api("/api/library");
      if (!libOK(l)) throw new Error("library payload not usable");
      try { localStorage.wl_lib = JSON.stringify({ t: Date.now(), d: l }); } catch (e) {} }
    return l; })().then(l => {
      S.cards = l.cards; strip(); panel(); chipsUI(); cartCount(); reshapePage(); nativeInject();
      // Artwork PDPs genuinely need the library (handle -> card lookup), so they
      // mount here — but the customiser download already finished in parallel,
      // so this is one round trip, not three. The print page mounted long ago
      // and only needs its Complete-the-Set band filling in.
      wlcReady().then(ok => { if (!ok) return;
        if (IS_OWN) { try { if (window.WLC && WLC.setCards) WLC.setCards(S.cards); } catch (eSC) {} }
        else if (PAGE_CARD && document.getElementById("wlpdpmount")) {
          // already built from the page card: hand over the cards for Complete-the-Set
          try { if (window.WLC && WLC.setCards) WLC.setCards(S.cards); } catch (eSC2) {}
          try { const lc = S.cards.find(x => x.url && x.url.indexOf("/products/" + location.pathname.split("/products/")[1].split("?")[0].split("/")[0]) >= 0);
                if (lc && String(lc.index) !== String(PAGE_CARD.index)) console.warn("wl: page card index", PAGE_CARD.index, "differs from library", lc.index); } catch (eLC) {} }
        else { mountPdp();
          // A product that is not in the library has no custom UI to build —
          // that is not a failure, so reveal the theme's own buy box rather than
          // holding the cover until the 20s backstop calls it a dead page.
          if (IS_PDP && !document.getElementById("wlpdpmount"))
            document.body.classList.add("wl-c-ready"); } });
      if (!IS_PDP) new MutationObserver(() => { clearTimeout(window.__wlmo);
        window.__wlmo = setTimeout(() => { nativeInject(); twoUpMobile();
          if (!document.getElementById("wlstriprow")) strip();    // self-heal the toolbar row
          const g = natGrid(); if (g) forceReveal(g.container); }, 400); })
        .observe(document.body, { childList: true, subtree: true });
      if (!IS_PDP) setTimeout(() => { if (!document.getElementById("wlstriphome")) strip(); }, 900);
      if (!IS_PDP) window.addEventListener("resize", () => { clearTimeout(window.__wlrs);
        window.__wlrs = setTimeout(() => {
          const row = document.getElementById("wlstriprow"); if (!row) return;
          const tb = document.querySelector(".collection-toolbar");
          const wantTb = window.innerWidth > 700 && !!tb;
          if (wantTb !== !!(tb && tb.contains(row))) row.remove();   // relocate across the 700px boundary
          strip(); }, 250); });
      // front-page handoff + back-to-search restore (R1/R6) — catalogue only:
      // on the home page the bar hands off, never restores (it would bounce the visitor)
      if (!IS_PDP && !IS_HOME) { try {
        const u = new URL(location.href);
        const wlq = u.searchParams.get("wlq");
        // PDP tag chips land here with ?wlartist= / ?wltype= — preset the filter
        // dropdowns so the page opens already narrowed (same CHIP pipeline as the
        // dropdowns themselves; wltype takes the dropdown's "Photo" alias)
        const wlartist = u.searchParams.get("wlartist"), wltype = u.searchParams.get("wltype");
        if (u.searchParams.get("wlsaved")) { showSaved(); }
        else if (wlq) { document.getElementById("wlq").value = wlq; search(false); }
        else if (wlartist || wltype) {
          if (wlartist) CHIP.artist = wlartist;
          if (wltype) CHIP.type = wltype === "Photography" ? "Photo" : wltype;
          applyChips();
        }
        if (u.searchParams.get("wlhelp")) helpOpen();
        if (u.searchParams.get("wlcam")) camOpen();
        if (!wlq && !wlartist && !wltype && localStorage.wl_restore === "1") {
          localStorage.wl_restore = "";
          const last = lastSearch();
          if (last && Date.now() - (last.t || 0) < 6 * 3600e3) {
            Object.assign(CHIP, last.chip || {});
            document.getElementById("wlq").value = last.q || "";
            if (last.results && last.results.length) {
              S.lastResults = last.results.map(byI).filter(Boolean); applyChips();
              document.getElementById("wlecho").innerHTML = 'Matches for your picture · <button class="lnk" id="wlclear5">All artworks</button>';
              const c5 = document.getElementById("wlclear5"); if (c5) c5.onclick = clearAll;
            } else if (last.q) { if (last.hints) { S.help.hints = last.hints; search(true); } else search(false); }
            else applyChips();
            setTimeout(() => window.scrollTo(0, last.y || 0), 700);
          } }
      } catch (e) {} }
    }).catch(err => { console.warn("wl boot:", err);
      // The library is unreachable or unusable. Everything above was skipped, so
      // nothing will ever signal ready — and the cover would hold until the
      // backstop showed "Something went wrong" on EVERY artwork page. Degrade to
      // the theme's own buy box instead, which sells perfectly well without us.
      // (audit 2026-08-24)
      try { document.body.classList.add("wl-c-ready"); } catch (e2) {} });
  } catch (err) { console.warn("wl studio bar:", err); }
})();

// ---- Enhancement PDP layout (Summer 2026-08-23) -----------------------------
// On /products/image-enhancement-300-dpi-print-master the try-it widget takes
// the media slot ("on the right side, replacing the existing image") and the
// gallery shrinks to a small thumbnail strip so the page isn't overwhelming.
// Also: global auto-height for enhance-widget iframes (kills the dead gap).
(function () {
  function boot() {
    // ONE height applier per page (Summer 2026-08-24) — see wl_customiser.js.
    // All three of customiser/search/bar load on the print page and each used to
    // run its own copy of this on every beat. First one in wires it.
    if (!window.__wlEnhHWired) {
      window.__wlEnhHWired = 1;
      window.addEventListener("message", function (e) {
        var d = e && e.data;
        if (!d || !d.wlEnhH) return;
        document.querySelectorAll('iframe[src*="enhance-widget"]').forEach(function (f) {
          if (f.contentWindow !== e.source) return;
          var before = f.getBoundingClientRect(), oldH = before.height;
          var newH = Math.max(90, Math.min(1400, +d.wlEnhH + 8));
          if (Math.abs(newH - oldH) < 1) return;    // unchanged — don't touch the DOM
          f.style.height = newH + "px";
          // keep the visitor's view anchored through a height change above
          // the fold — see wl_customiser.js for the root cause (2026-08-24)
          if (before.top < 0) window.scrollTo(0, window.scrollY + (newH - oldH));
        });
      });
    }
    // enhancement-PDP layout removed 2026-08-23: wl-bar never loads on that
    // template (order:["main"], no wl-studio-bar section) — the LIVE layout
    // code is in wl_search.js, which loads on every page. This file keeps
    // only the iframe auto-height handler above.
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
